export const en = {
  maintenance: {
    title: 'Maintenance',
    body: 'We are getting the next expansion ready. The site comes back on its own when it is done.',
  },
  card: {
    attr: {
      DARK: 'DARK',
      LIGHT: 'LIGHT',
      FIRE: 'FIRE',
      WATER: 'WATER',
      EARTH: 'EARTH',
      WIND: 'WIND',
    },
    race: {
      Aqua: 'Aqua',
      Beast: 'Beast',
      'Beast-Warrior': 'Beast-Warrior',
      Continuous: 'Continuous',
      Dinosaur: 'Dinosaur',
      Dragon: 'Dragon',
      Equip: 'Equip',
      Fairy: 'Fairy',
      Field: 'Field',
      Fiend: 'Fiend',
      Fish: 'Fish',
      Insect: 'Insect',
      Machine: 'Machine',
      Normal: 'Normal',
      Plant: 'Plant',
      Pyro: 'Pyro',
      Reptile: 'Reptile',
      Rock: 'Rock',
      'Sea Serpent': 'Sea Serpent',
      Spellcaster: 'Spellcaster',
      Thunder: 'Thunder',
      Warrior: 'Warrior',
      'Winged Beast': 'Winged Beast',
      Zombie: 'Zombie',
    },
    type: {
      'Normal Monster': 'Normal Monster',
      'Effect Monster': 'Effect Monster',
      'Flip Effect Monster': 'Flip Effect Monster',
      'Fusion Monster': 'Fusion Monster',
      'Spell Card': 'Spell Card',
      'Trap Card': 'Trap Card',
    },
    stType: {
      'Normal Spell': 'Normal Spell',
      'Equip Spell': 'Equip Spell',
      'Field Spell': 'Field Spell',
      'Continuous Spell': 'Continuous Spell',
      'Normal Trap': 'Normal Trap',
      'Continuous Trap': 'Continuous Trap',
    },
    token: {
      Normal: 'Normal',
      Effect: 'Effect',
      Fusion: 'Fusion',
      Flip: 'Flip',
    },
  },
  mobile: {
    rotateTitle: 'Turn your phone',
    rotateHint: 'Duels are played in landscape.',
    close: 'Close',
    closeMenu: 'Close menu',
    menu: 'Menu',
    filters: 'Filters',
  },
  nav: {
    brand: 'Dueling Chaos',
    home: 'Home',
    packs: 'Packs',
    deckBuilder: 'Deck Builder',
    collection: 'Collection',
    duel: 'Duel',
    duelPick: 'How do you want to play?',
    duelVsAi: 'Duel vs AI',
    duelVsAiHint: 'Your deck against the CPU.',
    duelRanked: 'Ranked online',
    duelRankedHint: 'Quick Match against another duelist.',
    duelCasual: 'Casual queue',
    duelCasualHint: 'Your league does not change.',
    duelEventHint: 'A weekly queue. A win pays a Master Pack. Your league does not change.',
    queueWaiting: '{n} in queue',
    queueClosed: 'Ranked is paused',
    rankedOfferHint: '{n} coins just for playing',
    duelCancel: 'Cancel',
    missions: 'Missions',
    news: 'News',
    banlist: 'Banlist',
    popular: 'Popular',
    tournaments: 'Tournaments',
    faq: 'FAQ',
    mailbox: 'Mailbox',
    language: 'Language',
    account: 'Account',
    settings: 'Settings',
    profile: 'Profile',
    friends: 'Friends',
    admin: 'Admin',
    rank: 'Ranked',
    menu: 'Account menu',
    loading: 'Loading',
    fullscreen: 'Full screen',
    fullscreenExit: 'Exit full screen',
  },
  splash: {
    skip: 'Skip',
  },
  coins: {
    balance: 'Coins',
  },
  interrupt: {
    toast: 'The duel was cut off by an update. We gave you {n} coins.',
  },
  bugReward: {
    toast: 'The bug you reported was real. We gave you 1 coin and 1 Master Pack.',
    toastMany: 'The bugs you reported were real. We gave you {n} coins and {n} Master Packs.',
  },
  staffGrant: {
    toastCoin: 'We gave you 1 coin.',
    toastCoins: 'We gave you {n} coins.',
    toastPack: 'We gave you 1 Master Pack.',
    toastPacks: 'We gave you {n} Master Packs.',
    toastBoth: 'We gave you {coins} coins and {packs} Master Packs.',
  },
  mailbox: {
    kicker: 'Account',
    title: 'Mailbox',
    lead: 'News to review, and messages from the team.',
    back: 'Home',
    news: 'News',
    messages: 'Messages',
    reviewNews: 'Review',
    team: 'Team',
    dialogTitle: 'Message',
    claim: 'Claim',
    claiming: 'Claiming…',
    claimed: 'Claimed',
    gotIt: 'Got it',
    close: 'Close',
    coin: '1 coin',
    coins: '{n} coins',
    pack: '1 Master Pack',
    packs: '{n} Master Packs',
    rewardBoth: '{coins} and {packs}',
    claimError: 'Could not claim this reward.',
    empty: 'No messages.',
    loading: 'Loading…',
    loadError: 'Could not load your mailbox.',
    pendingBadge: '{n} unread',
    clearSettled: 'Clear read and claimed',
    clearing: 'Clearing…',
    clearError: 'Could not clear the mailbox.',
    seasonCpu:
      'You finished #{position} on the {difficulty} CPU ladder this season. Here is 1 Master Pack.',
    playtimeMrd:
      'You are #{position} by time played. Here is a Metal Raiders special pack: 5 cards at Ultra Rare or higher.',
    playtimePack: '1 Metal Raiders special pack',
    tournament: {
      champion: 'You won the single-elimination tournament. Here are {coins} coins and a Master Pack.',
      finalist: 'You reached the final. Here are {coins} coins and a Master Pack.',
      semi: 'You reached the semifinals. Here are {coins} coins and a Master Pack.',
      quarters: 'You reached the quarterfinals. Here are {coins} coins and a Master Pack.',
      eighths: 'You reached the round of 16. Here are {coins} coins and a Master Pack.',
      play: 'You played the single-elimination tournament. Here is a Master Pack.',
    },
    eventQueue:
      'You finished #{position} on the {mode} event queue. Here is your prize.',
  },
  eventQueue: {
    kicker: 'This week',
    lead: 'Wins in the rotating event queue. A finished duel pays 7 coins for a win and 5 for a loss or draw, the same as ranked. When the week ends, the percent is counted among players with at least one win. You get one Master Pack band: 20 for the top 1%, 15 for the rest of the top 10%, 8 for the rest of the top 25%, 4 for the rest of the top 50%, and 2 for the rest. A tie on wins and losses at the cutoff takes the higher band.',
    board: 'This week',
    boardEmpty: 'No wins yet.',
    empty: 'No event is running.',
    loading: 'Loading…',
    liveUntil: 'Ends {time}',
    endsIn: 'Ends in {time}',
    closed: 'This event has ended.',
    modes: {
      random_deck: 'Random deck',
      unlimited: 'Unlimited',
      one_copy: '60 · one copy',
    },
    modeHints: {
      random_deck: 'A new Standard list each duel. You do not bring a deck.',
      unlimited: 'Your cards. Three copies, no house banlist.',
      one_copy: 'Your cards. Sixty in the Main, one of each name.',
    },
  },
  tournament: {
    kicker: 'Single elimination',
    title: 'Tournaments',
    history: 'Tournament history',
    historyLead: 'The last 10 finished tournaments. Open one to see the bracket and the decks.',
    empty: 'No finished tournaments yet.',
    upcoming: 'Sign-up opens at {time}',
    countdown: 'Starts in {time}',
    waitHours: '{n} hours until the next tournament.',
    waitHour: '1 hour until the next tournament.',
    waitMinutes: '{n} minutes until the next tournament.',
    waitMinute: '1 minute until the next tournament.',
    waitSoon: 'The next tournament is about to start.',
    waitJoin: 'Sign up and play for the rewards.',
    joinWindow: 'You can sign up in the last 30 minutes. The button shows up here.',
    registration: 'Sign-up is open',
    openTitle: 'Sign-up is open',
    openBody: 'The next tournament is taking names. About {minutes} minutes left. Sign up and play for the rewards.',
    notice2hTitle: '2 hours left',
    notice2hBody: 'The next tournament starts in 2 hours.',
    notice1hTitle: '1 hour left',
    notice1hBody: 'The next tournament starts in 1 hour.',
    notice5mTitle: '5 minutes left',
    notice5mBody: 'The tournament starts in 5 minutes. Sign up if you have not yet.',
    notice1mTitle: '1 minute left',
    notice1mBody: 'The tournament starts in 1 minute.',
    openBracket: 'View bracket',
    sampleBadge: 'Sample',
    registered: '{n} of {max} signed up',
    join: 'Sign up',
    leave: 'Leave sign-up',
    joined: 'You are signed up. That deck stays locked until the tournament ends.',
    pickTitle: 'Choose your deck',
    pickBody:
      'This deck stays locked until the tournament ends. You can still play it in other duels. Leaving sign-up unlocks it.',
    pickConfirm: 'Sign up with this deck',
    closedSoon: 'Sign-up is closed. Less than 30 seconds left.',
    autoJoined: 'You were signed up with “{name}”, the deck you use in duels.',
    live: 'Tournament in progress',
    sample: 'Sample bracket. It is not a real tournament.',
    spectate: 'Watch',
    replay: 'Replay',
    play: 'Play my match',
    rejoin: 'Back to my duel',
    bye: 'Bye',
    legend: 'Guide',
    markPlay: 'Won the duel',
    markShow: 'Won on the 5-minute check-in',
    markTime: 'Won on time',
    markNoShow: 'Did not enter the room',
    markBye: 'Bye',
    versus: '{a} vs {b}',
    advanced: '{name} advances',
    eighths: 'Round of 16',
    quarters: 'Quarterfinals',
    semi: 'Semifinals',
    final: 'Final',
    champion: 'Champion',
    podiumTitle: 'Hall of champions',
    podiumLead: 'The three duelists with the most tournament wins.',
    podiumWins: '{n} titles',
    podiumWin: '1 title',
    podiumAria: 'Place {place}: {name}, {wins}',
    players: '{n} duelists',
    duration: 'Total time {time}',
    decks: 'Decks',
    main: 'Main',
    extra: 'Extra',
    waiting: 'Waiting for the next round',
    autosPaused: 'Automatic tournaments are paused.',
    roundClock: 'Round {time}',
    yourMatch: 'Your match is ready',
    callBody: '{name} is your opponent. You have {minutes} minutes to open the duel.',
    callLater: 'Not now',
    pushPrompt:
      'Confirm the permission in the address bar. If it does not appear, turn it on from the lock icon.',
    pushDeniedBrowser:
      'Notices are blocked. Turn them on from the lock in the address bar.',
    errors: {
      closed: 'Tournaments are paused.',
      full: 'This tournament is full.',
      busy: 'You are already in a duel or a queue.',
      deck: 'That deck cannot be used.',
      banlist: 'That deck breaks the banlist.',
      unowned: 'That deck uses cards you do not own.',
      not_open: 'Sign-up is not open.',
      closed_soon: 'Sign-up closed with 30 seconds left.',
    },
  },
  seasonReward: {
    final: 'The season ended. You finished in {league} and received {n} boosters.',
    start: 'A new season started. You got a Metal Raiders booster.',
  },
  level: {
    title: 'Account level',
    lead:
      'Duel to earn XP. Your ranked league is separate and does not change this.',
    chip: 'Lv {n}',
    bar: '{into} / {need} XP',
    max: 'Max level',
    kicker: 'Server',
    loading: 'Loading levels…',
    board: 'Top levels',
    boardEmpty: 'Duel to earn XP and show up here.',
    place: 'Rank {n} on the server',
    viewLadder: 'See the level ladder',
    nextCoins: 'Next: {n} coins',
    nextPack: 'Next: 1 booster',
    nextBoth: 'Next: 1 booster and {n} coins',
    xpGain: '+{n} XP',
    xpProgress: 'Level progress',
    levelUp: 'Level {n}',
    grantCoins: '+{n} coins',
    grantPack: '1 booster',
    grantBoth: '1 booster and {n} coins',
  },
  aiWins: {
    kicker: 'Vs AI',
    lead:
      'Each CPU difficulty from Hard up has its own ladder. Easy and Normal are not listed. Only finished wins from this season count.',
    rewardTitle: 'Vs CPU ladder prize',
    rewardPlace: 'Place',
    rewardRange: '1–{n}',
    rewardNote:
      'Paid by mail when the season ends, ranked by vs CPU wins. A tie for place {n} is included. Hard, Expert, and Master each pay on their own.',
    loading: 'Loading wins…',
    board: 'Wins',
    empty: 'Win a vs AI duel on {name} to show up here.',
    one: '1 win',
    many: '{n} wins',
    place: 'Rank {n} on the server',
  },
  auth: {
    loginTitle: 'Sign in',
    loginLead: 'Use your email or username. You need an account to use Dueling Chaos.',
    registerTitle: 'Create account',
    registerLead:
      'A Gmail, Outlook, or Hotmail address, a public username, and a password. ' +
      'Email is how you sign in and how you reset the password if you lose it.',
    identifier: 'Email or username',
    loginPlaceholder: 'you@email.com or username',
    email: 'Email',
    username: 'Username',
    password: 'Password',
    passwordHint: 'At least 4 characters',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    signIn: 'Sign in',
    createAccount: 'Create account',
    noAccount: 'No account yet?',
    goRegister: 'Create one',
    haveAccount: 'Already have an account?',
    goLogin: 'Sign in',
    forgotLink: 'Forgot your password?',
    forgotTitle: 'Reset password',
    forgotLead:
      'Enter the email on your account. If it matches, we send a link that works for 30 minutes.',
    forgotSend: 'Send link',
    forgotSent:
      'If that email has an account, we sent a link. It expires in 30 minutes.',
    resetTitle: 'Choose a new password',
    resetLead:
      'This link works once. After you save, other sessions on this account sign out.',
    resetSave: 'Save password',
    resetMissing: 'This link has no code. Ask for a new one.',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    logout: 'Sign out',
    signedIn: 'Signed in as {name}',
    errors: {
      email_domain:
        'Use a Gmail, Outlook, or Hotmail address. We keep it as your login ' +
        'and to reset your password.',
      email_taken: 'That email is already registered.',
      username_taken: 'That username is taken.',
      username_cooldown: 'You can change your name again in 30 days.',
      invalid_credentials: 'Wrong email, username, or password.',
      validation: 'Check the fields and try again.',
      rate_limited: 'Too many tries. Wait a minute and try again.',
      database_unavailable:
        'The server cannot reach the database right now. Start local Postgres or use the live site.',
      network: 'Could not reach the server.',
      expired: 'Your session ended. Sign in again.',
      forgot_limited:
        'Too many reset emails from this network. Wait an hour and try again.',
      reset_invalid: 'This link is invalid or expired. Ask for a new one.',
      password_mismatch: 'The passwords do not match.',
    },
  },
  chat: {
    show: 'Chat',
    global: {
      title: 'Global chat',
      tab: 'Global',
      placeholder: 'Message...',
      send: 'Send',
      show: 'Global chat',
      hide: 'Hide chat',
      online: '{n} online',
      expand: 'Expand chat',
      medium: 'Medium size',
      full: 'Full screen',
      shrink: 'Normal size',
      resize: 'Drag to resize the chat',
      move: 'Drag to move',
      mentionList: 'Duelists online',
      mentionNone: 'No one else is online',
      mentionMiss: 'That duelist is not online',
      profile: 'Public profile of {name}',
      latest: 'Latest',
      muteOn: 'You muted {name}. Their messages no longer appear for you.',
      muteOff: 'You can see messages from {name} again.',
      muteAlready: 'You already muted {name}. Type /unmute {name} to see them again.',
      unmuteAlready: '{name} is not muted.',
      muteSelf: 'You cannot mute yourself.',
      muteMissing: 'No duelist uses that name.',
      muteUsage: 'Type /mute and the name. To see them again, type /unmute and the name.',
      muteFail: 'Could not change the mute. Try again.',
    },
    duel: {
      tab: 'Duel',
    },
    dm: {
      close: 'Close chat with {name}',
      placeholder: 'Message {name}',
      notFriends: '{name} is not on your friend list.',
      failed: 'Could not send that message.',
    },
  },
  friends: {
    kicker: 'Account',
    title: 'Friends',
    lead: 'Add a duelist by their exact name. Chat and room invites are only for friends.',
    back: 'Home',
    add: 'Add',
    addLabel: 'Username',
    loading: 'Loading friends…',
    loadError: 'Could not load friends. Try again.',
    empty: 'No friends yet.',
    incoming: 'Requests',
    outgoing: 'Sent',
    list: 'Friends',
    accept: 'Accept',
    decline: 'Decline',
    cancel: 'Cancel',
    remove: 'Remove',
    chat: 'Chat',
    invite: 'Direct duel',
    sent: 'Request sent to {name}.',
    accepted: 'You and {name} are friends.',
    acceptedMany: '{n} duelists accepted your friend request.',
    presence: {
      online: 'Online',
      in_duel: 'In a duel',
      offline: 'Offline',
    },
    requestIncoming: '{name} sent you a friend request.',
    pendingBadge: '{n} friend requests',
    inviteIncoming: '{name} invited you to a private room.',
    inviteAccept: 'Join',
    inviteDecline: 'Not now',
    inviteDeclined: '{name} declined the room.',
    errors: {
      invalid_username: 'That name is not valid.',
      user_not_found: 'No duelist uses that name.',
      cannot_friend_self: 'That is your own name.',
      already_friends: 'You are already friends.',
      request_pending: 'That request is already waiting.',
      friend_cap: 'The friend list is full.',
      request_cap: 'Too many requests waiting.',
      not_friends: 'You are not friends.',
      request_missing: 'That request is gone.',
      rate_limited: 'Too many tries. Wait a minute.',
      database_unavailable: 'Friends are unavailable right now.',
      network: 'Could not reach the server.',
      friends_failed: 'Could not update friends. Try again.',
    },
  },
  profile: {
    title: 'Profile',
    lead: 'What others see: your name, portrait, league, record, time played, and the prints you pin.',
    account: 'Account',
    name: 'Display name',
    nameHint:
      'This name is what others see in chat and online duels. Chat lines switch to the new name. You can change it once every 30 days.',
    nameCooldown: 'You can change your name again on {date}.',
    placeholder: 'Player',
    save: 'Save',
    saved: 'Saved',
    tabs: {
      you: 'You',
      case: 'Case',
      look: 'Duel look',
    },
    public: {
      view: 'See your public page',
      edit: 'Edit your case',
      loading: 'Loading this duelist…',
      missing: 'No duelist uses that name.',
      rateLimited: 'Too many lookups in a row. Wait a minute and open the profile again.',
      unavailable: 'Could not load this profile. Try again.',
      online: 'Online duels',
      rankedPlace: 'Ranked #{n}',
      levelPlace: 'Level ladder #{n}',
      aiPlace: '{name} #{n}',
      betaPlayer: 'Beta Player',
      betaTitle: 'Finished placement in the beta season as {league}',
      record: '{wins}–{losses}',
      recordDraws: '{wins}–{losses}–{draws}',
      noDuels: 'No duels yet',
      historyTitle: 'Duels',
      historyEmpty: 'No duels yet.',
      replay: 'Replay',
      modes: {
        ai: 'vs CPU',
        pvp_casual: 'Casual vs {name}',
        pvp_ranked: 'Ranked vs {name}',
        pvp_event: 'Event vs {name}',
      },
      results: {
        win: 'Win',
        loss: 'Loss',
        draw: 'Draw',
      },
      mute: 'Mute',
      unmute: 'Muted',
      muteTitle: 'Their messages disappear for you only',
      unmuteTitle: 'Tap to see their messages again',
      playTime: 'Time played: {time}',
      playMinutes: '{n} min',
      playHours: '{n} h',
      playHoursMinutes: '{h} h {m} min',
    },
    showcase: {
      title: 'Foil case',
      lead:
        'Pin up to six prints from your album. The first slot is the ' +
        'centerpiece. Other duelists see this on your public page.',
      publicLead: 'Prints this duelist chose to show.',
      emptyOwn: 'Your case is empty. Tap a slot and pick a print.',
      emptyPublic: 'This duelist has not pinned any prints yet.',
      editHint:
        'Tap a card or a numbered slot to change it. If you own several copies of the same card and rarity, each one can take a slot.',
      allPinned: 'Every copy of this print is already in the case.',
      pick: 'Pick a print',
      search: 'Search your album',
      needAlbum: 'Open packs so you have prints to show.',
      clear: 'Clear this slot',
      prev: 'Previous',
      next: 'Next',
      page: '{from}–{to} · {page}/{pages}',
    },
    avatar: {
      title: 'Portrait',
      photo: 'Chat photo',
      random: 'Shuffle',
      reset: 'Reset',
      artTitle: 'Artwork',
      framesTitle: 'Frame',
      frames: {
        gold: 'Gold',
        silver: 'Silver',
        obsidian: 'Obsidian',
        ivory: 'Ivory',
        crimson: 'Crimson',
        azure: 'Azure',
        bronze: 'Bronze',
        emerald: 'Emerald',
        'last-call': 'Last Call',
        'league-duelist': 'Duelist',
        'league-challenger': 'Challenger',
        'league-champion': 'Champion',
        'league-king': 'King of Games',
      },
      leagueHint:
        'Reach a league in ranked to unlock its frame. It stays yours for good.',
    },
    look: {
      title: 'Duel look',
      lead: 'The playmat and sleeve you take into vs AI and online duels.',
    },
  },
  rank: {
    title: 'Ranked',
    kicker: 'Season',
    lead: 'Quick Match is ranked. Private rooms and vs AI do not change your league.',
    loading: 'Loading your league…',
    loadError: 'Could not load the ladder.',
    retry: 'Try again',
    back: '← Back to Home',
    play: 'Play ranked',
    viewLadder: 'See the ladder',
    seasonSince: 'Season started {date}',
    you: 'You',
    placement: 'Placement',
    placementLeft: 'Placement: {n} duels left',
    lpCount: '{lp} / 100 LP',
    lpBare: '{lp} LP',
    lpLine: '{name} · {lp} LP ({delta})',
    lpProgress: 'League points',
    promoted: 'Promoted!',
    promoPack: '+1 booster',
    promoPacks: '+{n} boosters',
    seasonPacks: '+{n} boosters at season end',
    rewardsTitle: 'League prizes',
    rewardsLead:
      'When the season closes, anyone who finished placement gets Master Packs for the league they ended in.',
    rewardsLeague: 'League',
    rewardsPrize: 'Prize',
    rewardPack: '1 Master Pack',
    rewardPacks: '{n} Master Packs',
    rewardsClimb:
      'Climbing a league grants {league} Master Packs right away. Climbing a division grants {division} Master Pack. That league’s sleeve, playmat, and frame stay yours.',
    cosmeticsUnlocked: 'New {league} league set',
    cosmeticsWhere: 'Sleeve, playmat, and frame. Equip them in your profile.',
    demoted: 'Demoted',
    board: 'This season',
    boardEmpty: 'Win ranked duels to appear here.',
    prev: 'Previous',
    next: 'Next',
    pager: '{page} / {pages}',
    pagerLabel: 'Ladder pages',
    prizesLead: 'What is paid when the season closes.',
    tabs: {
      ranked: 'Ranked',
      level: 'Level',
      prizes: 'Prizes',
      event: 'Event',
    },
    leagues: {
      duelist: 'Duelist',
      challenger: 'Challenger',
      champion: 'Champion',
      king: 'King of Games',
    },
  },
  home: {
    title: 'Dueling Chaos',
    kicker: '',
    vsAi: 'Duel vs AI',
    vsAiHint: 'Your deck against the CPU.',
    vsAiPick: 'Choose CPU difficulty',
    vsAiStart: 'Start duel',
    vsAiCancel: 'Cancel',
    vsAiTag: 'Solo',
    playOnline: 'Play Online',
    onlineHint: 'Ranked Quick Match against another duelist.',
    casual: 'Casual queue',
    casualTag: 'Unranked',
    casualHint: 'Your league does not change.',
    eventTag: 'Event',
    eventHint: 'A weekly queue. A win pays 7 coins; a finished loss or draw pays 5, the same as ranked. When the week ends, Master Packs go by percent of players with a win: 20 for the top 1%, 15 for the rest of the top 10%, 8 for the rest of the top 25%, 4 for the rest of the top 50%, and 2 for the rest.',
    eventRankHint: 'The board is in {rank}, under {tab}.',
    queueWaiting: '{n} in queue',
    queueClosed: 'Ranked is paused',
    rankedOffer: 'Play one ranked match and get {n} coins.',
    onlineTag: 'PvP',
    rank: 'Top players',
    rankTag: 'Ladders',
    rankHint: "This season's leagues, account levels, and vs AI wins from Hard up.",
    rooms: 'Private rooms',
    roomsHint: 'See open rooms or create one. Not ranked.',
    roomsTag: 'Casual',
    watch: 'Watch duels',
    watchTag: 'Live',
    watchHint: 'Spectate ranked matches and private rooms. Hands stay hidden.',
    packs: 'Packs',
    packsHint: 'Open boosters and grow your collection.',
    packsTag: 'Boosters',
    missions: 'Missions',
    missionsTag: 'Rewards',
    missionsHint: 'Daily tasks and ranked matches, for coins and a shop pack.',
    collection: 'Collection',
    collectionHint: 'The album: what you own and what you still need.',
    collectionTag: 'Album',
    deckBuilder: 'Deck Builder',
    deckHint: 'Build and save the list you take to battle.',
    deckTag: 'Prepare',
    using: 'Your deck: {name}',
    playDeck: 'Duel with',
    deckNotReady: ' (not ready)',
    changelog: "What's new",
    changelogHint: 'What changed in the game lately.',
    banlistHint: 'Max 1 or 2 copies. The list changes with the meta. Ranked, casual, rooms, and versus the CPU.',
    popularHint: 'Which cards show up most, which ones travel with them, and how often those decks win.',
    faqHint: 'How to sign up for a tournament, the banlist, and daily reward limits.',
    cardsRestoredTitle: 'Your cards',
    cardsRestoredOne:
      'We gave back the 1 card you had before the reset. It is in your collection, added on top of the ones you got after. There will be no more resets. Thanks for playing.',
    cardsRestoredMany:
      'We gave back the {n} cards you had before the reset. They are in your collection, added on top of the ones you got after. There will be no more resets. Thanks for playing.',
    letterKicker: 'From the developers',
    letterTitle: 'A note',
    letterThanks:
      'First of all, I want to thank all of you for the support and for playing so much.',
    letterTesting:
      'I want to let you know that **Metal Raiders** is already being tested. The cards are about **90%** done, but I am asking for patience, because other things still need work: rewards, ranked balance, and other systems I want tuned before the Metal Raiders release.',
    letterRewards:
      'I know the game is in a somewhat wild state right now, with many copies of strong cards, but that is on purpose. The point of this stage was to test the game and fix bugs so we have a solid base before more updates. That is why rewards in both ranked and vs CPU are extremely high. You can open a lot of packs and own a lot of cards in a few hours. That has let everyone try every card and report bugs. Thank you for that.',
    letterBanlist:
      'I know a banlist has come up a lot. My idea is something different: **RNG**, the large card pool, and rewards much lower than they are now should keep the game in balance. If that does not work, then we will have to start thinking about a banlist.',
    letterBreak:
      'We are taking one or two days off, and then the work continues. I hope you understand, and thank you again.',
    noticeCollect: 'Got it',
    noticeExpand: 'Expand',
    keepAllKicker: 'Notice',
    keepAllTitle: 'No more resets',
    keepAllLead:
      'There will be no more resets of anything at all. Your **cards**, **coins**, **packs**, everything stays.',
    keepAllRank:
      'The only thing that resets is the [[ranking]] each [[season]].',
    nextSetKicker: 'Next set of cards',
    nextSetTitle: 'Spell Ruler',
    nextSetArtAlt: 'Spell Ruler booster pack',
    lastCall:
      'Last Call. Only finished PVP ranked matches count. Versus the CPU does not. {current} of {target}.',
    lastCallOpen: 'See the rewards',
    nextSetLead:
      'We are **focused** on working on **Spell Ruler**. It should be ready in about **3 weeks**.',
    nextSetReset:
      'Each time a new expansion or set of cards is released, [[we reset]] [[the cards you obtained]], your [[coins]], your [[league]], and your [[level]]. Your **collection does not reset**. The reset stops players who already have more and better cards from locking the top, gives new players a chance to climb, and encourages variety in decks.',
    nextSetRewards:
      'There will be **rewards** for everyone who **took part and helped** improve the game, and also for **those who played the most**. Players who finished in the **ranked** top and the **vs CPU** top get **cosmetic** rewards and **packs**.',
    pollTitle: 'Reset the collection?',
    pollLead: 'Vote on whether the collection should reset too when a new set arrives.',
    pollYes: 'Yes',
    pollNo: 'No',
    pollTally: '{yes} yes · {no} no',
    pollSaved: 'Vote saved. You can change it.',
    pollFolded: 'You voted {vote}. Tap to change it.',
    pollRewardTitle: 'Rewards for the top',
    pollRewardLead:
      'Write the rewards you want for the players who finish on top after the reset. They can be cosmetics or cards.',
    pollRewardPlaceholder: 'A playmat, sleeves, a specific card…',
    pollRewardSend: 'Send suggestion',
    pollRewardThanks: 'We got your suggestion.',
    pollError: 'Could not save. Try again.',
    pollLoadError: 'Could not load the poll.',
    pollRate: 'Wait a moment before sending again.',
    banPollTitle: 'Forbidden cards?',
    banPollLead:
      'Right now the list only limits cards: you can play 1 copy. A forbidden card cannot be played, which means 0 copies in the deck. Do you want them now, or only limited cards for the time being?',
    banPollForbidden: 'I want forbidden cards',
    banPollLimited: 'Only limited cards for now',
    banPollResults: 'Votes so far',
    banPollCount: '{count} · {pct}%',
    banPollTally: '{forbidden} want forbidden cards · {limited} limited only',
    banPollEmpty: 'No votes yet.',
    banPollCommentTitle: 'Additional comment',
    banPollCommentLead: 'Add anything else you want to say about forbidden cards.',
    banPollCommentPlaceholder: 'Your comment…',
    banPollCommentSend: 'Send comment',
    banPollCommentThanks: 'We got your comment.',
  },
  discord: {
    join: 'Join Discord',
  },
  support: {
    tip: 'Donate',
    title: 'Donate',
    lead: 'These packs add coins to your account. A shop pack costs 20 coins.',
    rowCoins: '{n} coins',
    rowPacks: '{n} packs',
    other: 'Donate another amount',
    otherNote: 'You choose the amount. That donation does not add coins.',
    signIn: 'Sign in to receive the coins',
    close: 'Close',
    failed: 'PayPal did not open. Try again.',
  },
  thanks: {
    kicker: 'Thank you',
    title: 'Dark Magician Girl blows you',
    accent: 'a kiss',
    lead: 'Your support keeps the duel going.',
    coins: 'We added {n} coins to your account.',
    coinsLater: 'If you already paid, the coins land on your account.',
    back: 'Back to home',
    artAlt: 'Dark Magician Girl winking and blowing a kiss',
  },
  pwa: {
    title: 'Install the app',
    lead: 'Install Dueling Chaos on this device. It opens full screen, like a native app.',
    hint: 'Adds an icon on your home screen or desktop. Duels fill the screen.',
    install: 'Install Dueling Chaos',
    installed: 'This device already has Dueling Chaos installed.',
    ios: 'On iPhone or iPad: tap Share, then Add to Home Screen.',
    manual: 'Use your browser menu to install this site as an app.',
  },
  push: {
    title: 'Tournament notices',
    body: 'The same tournament notices can arrive with Dueling Chaos closed: 2 hours, 1 hour, when sign-up opens, 5 minutes, 1 minute, and when your duel is ready.',
    enable: 'Turn on notices',
    later: 'Not now',
  },
  changelog: {
    kicker: 'Updates',
    title: "What's new",
    lead: 'Notes for duelists. Switch language anytime from the menu in the top bar.',
    dialogLead: 'Changes from the last 3 days.',
    dismiss: 'Got it',
    open: 'See all',
    pending: 'Unread updates',
    back: '← Back to Home',
  },
  meta: {
    kicker: 'This season',
    title: 'Most played cards',
    lead: 'Cards duelists bring this season when a duel starts. Usage is the share of decks. That bar fills against the most played card. Wins count finished duels only. The number beside a stat is how the last 7 days of this season moved versus the 7 days before. Tap a card to see which cards travel with it.',
    back: '← Back to Home',
    modes: 'Mode',
    all: 'All',
    ranked: 'Ranked',
    top: 'Top',
    topHint: 'Champion and King of Games only, in ranked.',
    casual: 'Casual',
    ai: 'Vs AI',
    sort: 'Sort',
    sortUsage: 'Most played',
    sortWin: 'Win rate',
    winFloor: 'Win rate ranks cards in at least {n} finished duels.',
    decks: '{n} decks',
    usage: '{n}% of decks',
    usageShort: 'Usage',
    win: '{n}% wins',
    winShort: 'Wins',
    winEmpty: 'No finished duels',
    sample: '{n} duels',
    copies: '{n} copies per deck',
    copiesSplit: '1× {a}% · 2× {b}% · 3× {c}%',
    deltaUsage: 'Last 7 days {n} versus the 7 days before',
    deltaWin: 'Last 7 days {n} versus the 7 days before',
    with: 'Played with',
    withClose: 'Close',
    withSample: '{n} decks play this card.',
    withLead: 'The percent is how many of those decks also play the other card.',
    withShare: '{n}% of decks that play this',
    withEmpty: 'No cards travel with this one this season yet.',
    empty: 'No duels this season yet.',
    loadError: 'Could not load the list.',
    retry: 'Try again',
    loading: 'Loading',
    place: 'Rank {n}',
  },
  banlist: {
    kicker: 'Every duel',
    title: 'Banlist',
    lead: 'Copy limits in ranked, the casual queue, private rooms, and versus the CPU. Your deck follows them too. The list stays, and it changes with the meta.',
    limited1: 'Limited — max 1',
    limited2: 'Semi-Limited — max 2',
    max: 'Max {n}',
    back: '← Back to Home',
  },
  banlistReward: {
    kicker: 'New duelist',
    title: 'Choose a banlist card',
    lead: 'Pick one card. {n} choices are open.',
    leadOne: 'Pick one card. This choice is open.',
    owned: 'You have {n}',
    max: 'Max {n} in a deck',
    confirm: 'Add {name}?',
    confirmBody: 'One Common copy goes into your collection.',
    add: 'Add',
    adding: 'Adding…',
    back: 'Back',
    later: 'Later',
    profileChoose: 'Choose a banlist card',
    profileLeft: '{n} to choose',
    profileNext: 'The next banlist card unlocks at level {n}.',
    gameOver: 'You can choose a banlist card.',
    gameOverChoose: 'Choose a card',
    error: 'That card could not be added. Try again.',
    empty: 'The banlist is empty right now.',
  },
  faq: {
    kicker: 'Help',
    title: 'Frequently asked questions',
    lead: 'Automatic tournaments, the banlist, and daily reward limits.',
    back: '← Back to Home',
    items: {
      tournamentJoin: {
        q: 'How do I sign up for a tournament?',
        a: 'Sign-up is not open all day. It opens **30 minutes** before the start. The tournament card then shows a **Sign up** button. You pick a deck and you are in.\n\nThat card is on Home, on Duel, and on Tournaments. Before those 30 minutes the button is not there: the card says how long is left. Tapping the **5 minute** notice or the **last minute** notice also opens sign-up.',
      },
      tournamentWhen: {
        q: 'What time are the tournaments?',
        a: 'One starts every **3 hours**. The countdown on the card uses your clock. Sign-up opens in the last **30 minutes**.\n\nIf you are on the site when it opens, a notice appears. The bell on the card can also reach you with the site closed, if you allow it. Tap the slashed bell to turn those notices off.',
      },
      tournamentField: {
        q: 'How many seats are there, and when does it start?',
        a: 'There are **8** seats, single elimination, one duel per round. It starts as soon as those seats are full, or at the published time if they are not. Fewer than **4** duelists and it is called off, and nobody is paid.\n\nThese duels do not move your league.',
      },
      tournamentDeck: {
        q: 'Which deck do I use?',
        a: 'Signing up asks you to pick one. That deck cannot be edited until the tournament ends or you leave sign-up. Recycling stays closed while you are signed up. You can still use that deck in other duels.\n\nSign-up closes **30 seconds** before the start. If the deck list is still open then, you enter with the deck you use in duels.',
      },
      tournamentPlay: {
        q: 'What do I do when it is my match?',
        a: 'When your duel is ready, you get a notice. You have **5 minutes** to open it. If you do not enter and your opponent does, they advance. Each round lasts **40 minutes**.',
      },
      tournamentPrizes: {
        q: 'What do tournaments pay?',
        a: 'Prizes arrive in your mailbox when the tournament ends. Finishing a duel pays a Master Pack.\n\nWith **5** or more, the bracket is 8: quarterfinals pay **10** coins, semifinals **30**, the finalist **40**, and the champion **50**. If it starts with **4**, semifinals pay **20**, the finalist **30**, and the champion **40**. Surrendering your first duel pays nothing.',
      },
      banlist: {
        q: 'Does the banlist apply to every duel?',
        a: 'Yes. It applies in ranked, the casual queue, private rooms, and versus the CPU, including your own deck. CPU decks follow it on every difficulty, including Master.',
      },
      banlistMeta: {
        q: 'Is the banlist permanent?',
        a: 'Yes. It is no longer temporary. The list will change as the meta changes.',
      },
      rewardsLadder: {
        q: 'Does the ranked ladder have a daily limit?',
        a: 'Yes. On Missions, the first **10** finished Quick Matches of the day fill a ladder. Steps **1** to **9** each pay **3** coins. Step **7** also gives one shop pack, and step **10** gives two shop packs and no coins. From match 11 on, that ladder does not move until midnight UTC. Leaving a match does not count.',
      },
      rewardsMatch: {
        q: 'Do the coins from a ranked duel have a daily cap?',
        a: 'No. A win pays **7**, and a finished loss or draw pays **5**, every time. Surrendering pays nothing.',
      },
      rewardsEvent: {
        q: 'What do event-queue duels pay?',
        a: 'A win pays **7** coins, and a finished loss or draw pays **5**, the same as ranked. Surrendering pays nothing. These duels do not move your league. When the week ends, the percent is counted among players with at least one win, and you get one band: **20** Master Packs for the top 1%, **15** for the rest of the top 10%, **8** for the rest of the top 25%, **4** for the rest of the top 50%, and **2** for the rest. A tie on wins and losses at the cutoff takes the higher band.',
      },
      rewardsCall: {
        q: 'Does the note that someone is waiting have a limit?',
        a: 'It pays **1** extra coin, up to **20** times a day. After that, the note still appears and that extra coin is not paid. It resets at midnight UTC.',
      },
      rewardsDaily: {
        q: 'Do daily missions and the queue race reset?',
        a: 'Yes, at midnight UTC. Each mission and each race goal pays **3** coins. Finishing **7** of the **10** daily missions gives a shop pack. Collection missions do not reset.',
      },
    },
  },
  dialog: {
    snoozeToday: "Don't show again today",
  },
  eventQueueDialog: {
    kicker: 'This week',
    title: 'Event queue',
    lead:
      'One rotating queue at a time. **Wins** go on a public board. Ranked and casual do not change.',
    duelPay:
      'Each finished duel pays **7** coins for a win and **5** for a loss or draw, the same as ranked. Surrendering pays nothing.',
    prizes:
      'When the week ends, the percent is counted among players with at least one win. You get one Master Pack band: **20** for the top 1%, **15** for the rest of the top 10%, **8** for the rest of the top 25%, **4** for the rest of the top 50%, and **2** for the rest. A tie on wins and losses at the cutoff takes the higher band.',
    live: 'Live now',
    play: 'Join the queue',
    board: 'See the board',
    modes: {
      random_deck:
        'Each duel gives you a new Standard list. You do not pick a deck.',
      unlimited:
        'Your cards. Three copies of any name, no house banlist. 40–60 in the Main.',
      one_copy:
        'Your cards. At least 60 in the Main, and only one copy of each name.',
    },
  },
  lastCallDialog: {
    kicker: 'Event',
    lead:
      'For two weeks, finished PVP ranked matches unlock a frame, a portrait, a sleeve, a playmat, and a promo pack. The promo Blue-Eyes can be recycled like any other copy.',
    foil:
      'The pack holds one Blue-Eyes White Dragon in a random foil above Super Rare.',
    rules:
      'A loss counts too. Versus the CPU, private rooms, and leaving a match do not count.',
  },
  missions: {
    kicker: 'Daily',
    title: 'Missions',
    tabs: {
      daily: 'Daily',
      runner: 'Race',
      ranked: 'Ranked',
      collection: 'Collection',
      lastCall: 'Last Call',
    },
    runner: {
      lead:
        'The same five every day, from the queue race. Ranked, casual, and the event queue all count. Each one pays 3 coins. They reset at midnight UTC and stay off the board of 10.',
      'runner-cards-5': 'Jump 5 cards',
      'runner-cards-20': 'Jump 20 cards today',
      'runner-cards-40': 'Jump 40 cards today',
      'runner-steps-100': 'Reach 100 steps in one run',
      'runner-steps-400': 'Reach 400 steps in one run',
    },
    collection: {
      lead:
        'These missions do not reset. Each step pays once and counts the cards you already own. The hardest steps also give a shop pack.',
      family: {
        total: 'Total',
        set: 'Sets',
        kind: 'Card types',
        attribute: 'Attributes',
        race: 'Monster types',
        foil: 'Rarity',
        playset: 'Three copies',
      },
      total: 'Collect {n} different cards',
      totalAll: 'Complete the collection',
      set: 'Collect {n} cards from {set}',
      setAll: 'Complete {set}',
      kind: 'Collect {n} {kind}',
      attr: 'Collect {n} {attr} cards',
      attrAll: 'Complete {attr}',
      race: 'Collect {n} {race} cards',
      raceAll: 'Complete {race}',
      foil: 'Own {n} {foil} cards',
      playset: 'Own 3 copies of {n} cards',
      kinds: {
        normal: 'Normal Monsters',
        effect: 'Effect Monsters',
        spell: 'Spell Cards',
        trap: 'Trap Cards',
        fusion: 'Fusion Monsters',
      },
      kindAll: {
        normal: 'Collect every Normal Monster',
        effect: 'Collect every Effect Monster',
        spell: 'Collect every Spell Card',
        trap: 'Collect every Trap Card',
        fusion: 'Collect every Fusion Monster',
      },
      foils: {
        rare: 'Rare or better',
        super: 'Super Rare or better',
        ultra: 'Ultra Rare or better',
        special: 'with a special print',
      },
      packWinOne:
        'That collection step put a shop pack with your packs. You can open it whenever you want.',
      packWinMany:
        'Those collection steps put {n} shop packs with your packs. You can open them whenever you want.',
    },
    lead:
      'Finish 7 of 10 for a shop pack. Each mission pays 3 coins. Resets at midnight UTC.',
    rankedLead:
      'Steps 1 to 9 each pay 3 coins. Step 7 gives one shop pack and step 10 gives two. Leaving the match does not count. Resets at midnight UTC.',
    rankedOne: 'Finish 1 ranked match',
    rankedMany: 'Finish {n} ranked matches',
    rankedPackWinLead:
      'You finished {n} ranked matches today. The shop pack is already with your packs, and you can open it whenever you want.',
    rankedPackWinMany:
      'You finished {n} ranked matches today. The {packs} shop packs are already with your packs, and you can open them whenever you want.',
    lastCallLead:
      'Finish PVP ranked matches over these two weeks. Versus the CPU, private rooms, and leaving a match do not count. The promo Blue-Eyes can be recycled like any other copy.',
    lastCallClosed:
      'Last Call is closed. What you did not reach is not given out.',
    lastCallFrozen: 'The list is frozen.',
    lastCallUntil: 'Closes {date} UTC.',
    lastCall: {
      frame: 'Avatar frame',
      portrait: 'Blue-Eyes portrait',
      sleeve: 'Card sleeve',
      mat: 'Playmat',
      pack: 'Promo pack: Blue-Eyes White Dragon',
    },
    toastRanked: 'Ranked match {n} is ready to claim',
    back: '← Back to Home',
    empty: 'No missions available right now.',
    loadError: 'Could not load missions.',
    retry: 'Try again',
    claim: 'Collect',
    claimAll: 'Collect all',
    claimCta: 'Claim',
    claimed: 'Collected',
    progress: '{current} / {target}',
    remaining: '{n} missions left for your pack',
    remainingOne: '1 mission left for your pack',
    packUnlocked: 'Pack unlocked!',
    packPrize: 'Shop pack',
    packWinKicker: 'Reward',
    packWinTitle: 'You won a pack!',
    packWinLead:
      'You finished {n} daily missions. The shop pack is already with your packs, and you can open it whenever you want.',
    packWinOpen: 'Go to packs',
    packWinClose: 'Got it',
    railHint: 'Each step pays 3 extra coins',
    stepClaim: 'Collect step {n}',
    stepClaimed: 'Step {n} collected',
    stepDone: 'Mission {n} complete',
    stepTodo: 'Mission {n}',
    resetHint: 'Resets in {h}h {m}m (UTC midnight).',
    toastDone: 'Completed: {name}',
    toastDoneMany: 'You completed {n} missions',
    toastHint: 'Open Missions to claim your reward.',
    pendingBadge: '{n} to claim',
    category: {
      presence: 'Play',
      skill: 'Skill',
      flavor: 'Duel',
    },
    ids: {
      'play-1': 'Finish 1 duel',
      'play-ai-1': 'Play 1 duel against the CPU',
      'open-pack-1': 'Open 1 pack',
      'draw-15': 'Draw 15 cards',
      'play-3': 'Finish 3 duels',
      'play-ai-3': 'Play 3 duels against the CPU',
      'xp-40': 'Earn 40 XP from duels',
      'draw-40': 'Draw 40 cards',
      'open-pack-2': 'Open 2 packs',
      'play-5': 'Finish 5 duels',
      'xp-90': 'Earn 90 XP from duels',
      'draw-80': 'Draw 80 cards',
      'open-pack-5': 'Open 5 packs',
      'win-1': 'Win 1 duel',
      'win-lp-1': 'Win 1 duel by reducing Life Points to 0',
      'survive-2000-1': 'Win 1 duel with 2000 or more Life Points',
      'win-2': 'Win 2 duels',
      'win-ai-hard-1': 'Beat the CPU on Hard or higher',
      'win-fast-1': 'Win 1 duel in 8 turns or fewer',
      'survive-2000-2': 'Win 2 duels with 2000 or more Life Points',
      'win-lp-2': 'Win 2 duels by reducing Life Points to 0',
      'win-4': 'Win 4 duels',
      'win-ai-hard-3': 'Beat the CPU on Hard or higher 3 times',
      'win-fast-2': 'Win 2 duels in 8 turns or fewer',
      'survive-2000-4': 'Win 4 duels with 2000 or more Life Points',
      'win-lp-4': 'Win 4 duels by reducing Life Points to 0',
      'summon-8': 'Summon 8 monsters',
      'attack-10': 'Declare 10 attacks',
      'spell-5': 'Activate 5 Spell Cards',
      'damage-2000': 'Deal 2000 or more battle damage in one turn',
      'summon-20': 'Summon 20 monsters',
      'attack-25': 'Declare 25 attacks',
      'spell-15': 'Activate 15 Spell Cards',
      'trap-6': 'Activate 6 Trap Cards',
      'tribute-5': 'Tribute Summon 5 monsters',
      'fusion-1': 'Fusion Summon 1 monster',
      'damage-3500': 'Deal 3500 or more battle damage in one turn',
      'summon-40': 'Summon 40 monsters',
      'attack-45': 'Declare 45 attacks',
      'spell-28': 'Activate 28 Spell Cards',
      'trap-12': 'Activate 12 Trap Cards',
      'tribute-10': 'Tribute Summon 10 monsters',
      'fusion-3': 'Fusion Summon 3 monsters',
      'damage-5000': 'Deal 5000 or more battle damage in one turn',
    },
  },
  settings: {
    title: 'Settings',
    lead: 'How the app plays and how menus look on this device.',
    tabs: {
      play: 'Play',
      look: 'Menus',
      dev: 'Dev',
    },
    appearance: 'Appearance',
    theme: 'Theme',
    themeHint: 'Menu screens follow this. The duel board stays dark.',
    fullscreen: 'Full screen',
    fullscreenHint:
      'Hides the browser bars. In a duel, the top menu hides too so the board is larger. Press Esc to leave.',
    pushTitle: 'Tournament notices',
    pushHint: 'The countdown and the match-ready notice, even when the app is closed.',
    pushEnable: 'Turn on notices',
    pushDisable: 'Turn off notices',
    pushOn: 'This device gets tournament notices with the app closed.',
    pushMuted: 'Tournament notices are off on this device.',
    pushDenied: 'Notices are blocked. Turn them on for Dueling Chaos in your Android settings.',
    pushUnsupported: 'This browser cannot show notices with the app closed.',
    light: 'Light',
    dark: 'Dark',
    accent: 'Accent color',
    accentHint: 'Used on the selected page, chips, and highlights.',
    custom: 'Custom color',
    preview: 'Preview',
    presets: {
      gold: 'Gold',
      orange: 'Orange',
      coral: 'Coral',
      rose: 'Rose',
      pink: 'Pink',
      violet: 'Violet',
      indigo: 'Indigo',
      blue: 'Blue',
      cyan: 'Cyan',
      teal: 'Teal',
      green: 'Green',
      silver: 'Silver',
    },
    vsAi: 'Duel vs AI',
    vsAiHint:
      'Only applies against the computer. Online duels always roll the dice.',
    vsAiDifficulty: 'CPU difficulty',
    vsAiDifficultyHint:
      'Each vs AI duel picks a different published recipe for that difficulty. ' +
      'Higher levels play stronger lists. Every difficulty follows the banlist, and so does your deck. Winning on Hard, Expert, or Master ' +
      'pays more coins and XP. Every finished duel pays coins.',
    rankedPrompts: 'Ranked prompts',
    rankedPromptsHint:
      'Notes that someone is waiting for a ranked match. Finishing that match pays 1 coin, up to 20 times a day. After 20, the note still appears and that match pays no extra coin. Turn them off and those notes stay hidden, and that coin is not paid.',
    rankedPromptsOn: 'Show ranked prompts',
    vsAiTestHint:
      'The CPU only plays low-ATK Normal Monsters. This duel pays no coins or XP.',
    vsAiLevels: {
      test: 'Test',
      easy: 'Easy',
      normal: 'Normal',
      hard: 'Hard',
      expert: 'Expert',
      master: 'Master',
    },
    vsAiDecide: 'How the first turn is decided',
    vsAiDiceOn: 'Dice',
    vsAiDiceOff: 'Choose',
    vsAiFirst: 'Who goes first',
    vsAiYou: 'You',
    vsAiCpu: 'CPU',
    mat: 'Playmat',
    matHint:
      'Your half of the field. Online, the other duelist sees this playmat. Vs AI, the CPU gets a random playmat each duel.',
    followOpponent: 'Follow the opponent in the viewer',
    followOpponentHint:
      'When they summon, activate, or attack, that card appears in the viewer.',
    hideCardViewer: 'Hide the card panel',
    hideCardViewerHint:
      'Tucks the text on the right so the board is wider. Lists such as Monster Reborn and Big Eye hide it on their own while you pick.',
    coinQuality: 'Coin animation quality',
    coinQualityHint:
      'High spins the 3D coin. Low spins the same coin flat, and it is lighter if the 3D dialog was freezing the duel. Stays on this device.',
    coinQualityLevel: {
      high: 'High',
      low: 'Low',
    },
    motion: 'Animations',
    motionHint:
      'Full keeps particles and card flights. Reduced cuts particles, shakes, and field effects; cards still move. Minimal puts cards in place, with no 3D flights, no animated foil, and no field background. Stays on this device.',
    motionLevel: {
      full: 'Full',
      reduced: 'Reduced',
      minimal: 'Minimal',
    },
    imageQuality: 'Image quality',
    imageQualityHint:
      'Sharp draws the cards, the sleeves, and the ATK and DEF numbers with more detail. That is the starting choice. Standard asks less of a phone if it struggles. Refresh the page to see a change. Stays on this device.',
    imageQualityApply: 'Refresh the page to apply this change.',
    imageQualityLevel: {
      sharp: 'Sharp',
      standard: 'Standard',
    },
    foilSweep: 'Foil shine',
    foilSweepHint:
      'Full is the usual sweep across the card. Light asks less of a phone when the deck is full of foil, and the shine looks simpler. Stays on this device.',
    foilSweepMode: {
      full: 'Full',
      light: 'Light',
    },
    foilThumbs: 'Animate foil on small cards',
    foilThumbsHint:
      'The album, trunk, and lists sweep every foil. Off, those cards keep a still tint and only while they are on screen. The open card still sweeps. Stays on this device.',
    responseMode: 'When to ask about traps',
    responseModeHint:
      'Minimal is the starting choice: it only asks when a trap answers that play. Just Desserts also asks once at the start of the opponent\'s Battle Phase, if they control a monster. A face-down Ultimate Offering asks then too, and again when they declare an attack. Robbin\' Goblin asks at the start of your Battle Phase, and when the opponent attacks a face-down Defense monster of yours that would deal damage back. Counter Traps only ask when the opponent activates or summons something they can negate. Auto also prompts on summons, attacks, and as Battle Phase starts. All asks at every phase. Off never asks.',
    focusBands: 'Zoom the field on a phone',
    focusBandsHint:
      'In landscape, the camera stays on your hand, follows a play, then comes back. A button and a tap switch the view.',
    matOpacity: 'Opacity',
    matRandom: 'Random',
    matRandomHint: 'A different playmat each duel.',
    matCartoon: 'Cartoon',
    matFlat: 'Solid',
    sleeve: 'Sleeve',
    sleeveHint:
      'Face-down cards and your deck. Vs AI, the CPU gets a random sleeve each duel.',
    sleeveRandom: 'Random',
    sleeveRandomHint: 'A different sleeve each duel.',
    leagueRewards: 'League rewards',
    leagueLocked: 'Reach the {league} league',
    duel: 'Duel',
    duelHint:
      'Viewer, card art, and playmat for every duel on this device.',
    cardArt: 'Card artwork',
    cardArtHint:
      'The picture on the card. TCG is the default international illustration; ' +
      'OCG is the Japanese original. Most cards match. A few, like ' +
      'Monster Reborn, look different.',
    cardArtTcg: 'TCG',
    cardArtOcg: 'OCG',
    audio: 'Audio',
    audioHint:
      'Music and duel effects. Both sliders apply in menus, packs, and ' +
      'duels. Duel Sound off silences effects and music until you turn ' +
      'it back on.',
    music: 'Music',
    sfx: 'Sound effects',
    sleeves: {
      'millennium-gaze': 'Millennium Gaze',
      'heart-draw': 'Heart Draw',
      'kingdom-isle': 'Kingdom Isle',
      'city-skies': 'City Skies',
      'god-triad': 'God Triad',
      'ivory-wyrm': 'Ivory Wyrm',
      'dusk-staff': 'Dusk Staff',
      'carnival-ink': 'Carnival Ink',
      'crimson-iris': 'Crimson Iris',
      'five-relics': 'Five Relics',
      'classic-vortex': 'Classic Vortex',
      'sapphire-vortex': 'Sapphire Vortex',
      'emerald-vortex': 'Emerald Vortex',
      'amethyst-vortex': 'Amethyst Vortex',
      'rose-vortex': 'Rose Vortex',
      'silver-vortex': 'Silver Vortex',
      'last-call': 'Last Call',
      'league-duelist': 'Duelist',
      'league-challenger': 'Challenger',
      'league-champion': 'Champion',
      'league-king': 'King of Games',
    },
    mats: {
      'puzzle-dusk': 'Puzzle dusk',
      'white-sky': 'White sky',
      'moon-circle': 'Moon circle',
      'ember-wings': 'Ember wings',
      'sogen-hills': 'Green hills',
      'umi-tide': 'Tide',
      'sand-temple': 'Sand temple',
      'toon-fair': 'Carnival',
      'shadow-chains': 'Shadow chains',
      'kingdom-arena': 'Duel arena',
      'mystic-circle': 'Mystic circle',
      'forbidden-seal': 'Forbidden seal',
      'knight-charge': 'Knight charge',
      'elf-grove': 'Elf grove',
      'light-swords': 'Swords of light',
      'navy-puzzle': 'Navy puzzle',
      'crimson-eye': 'Crimson eye',
      'forest-leaf': 'Forest leaf',
      'gold-star': 'Gold star',
      'violet-moon': 'Violet moon',
      'charcoal-hex': 'Charcoal hex',
      'teal-drop': 'Teal drop',
      'ember-flame': 'Ember flame',
      'ivory-disk': 'Ivory disk',
      'slate-tribute': 'Slate tribute',
      'last-call': 'Last Call',
      'league-duelist': 'Duelist',
      'league-challenger': 'Challenger',
      'league-champion': 'Champion',
      'league-king': 'King of Games',
    },
    devTools: 'DevTools',
    devToolsHint: 'Development tools. Enter the password to unlock.',
    devToolsPassword: 'Password',
    devToolsUnlock: 'Unlock',
    devToolsWrong: 'Wrong password.',
    devToolsGrant: 'Grant all cards',
    devToolsGrantHint:
      'Puts every catalog card in your collection, with 3 copies of each rarity.',
    devToolsGranted: 'Done. Check the Collection or build a deck.',
    devToolsPacksHint:
      'Adds unopened Master Packs. Open them on Packs. No coins spent.',
    devToolsPacksX5: 'Claim x5',
    devToolsPacksX10: 'Claim x10',
    devToolsPacksGranted: 'Added {n} boosters. Open them under Packs.',
    devToolsFailed: 'Could not apply. Sign in and try again.',
    devToolsLock: 'Lock',
    devToolsReset: 'Reset this account',
    devToolsResetHint:
      'Wipes collection, decks, coins, XP, and ranked standing. You start again with the three starters.',
    devToolsResetDone: 'Account reset. Open your starters under Packs.',
    devToolsCoins: 'Add 100 coins',
    devToolsCoinsDone: 'Added 100 coins.',
    devToolsRank: 'Set ranked league',
    devToolsRankHint: 'Skips placement and writes this league on the account.',
    devToolsRankDone: 'League updated.',
    devToolsPlacement: 'Placement',
  },
  feedback: {
    title: 'Mailbox',
    lead:
      'Suggestions, complaints, or a bug. Signed in, so we know who sent it.',
    kind: 'What is this about',
    kinds: {
      suggestion: 'Suggestion',
      complaint: 'Complaint',
      bug: 'Bug',
    },
    reportBug: 'Report a bug',
    message: 'Message',
    placeholder: 'What happened, or what you would change…',
    send: 'Send',
    thanks: 'Thanks. We read every note.',
    thanksBug:
      'Thanks. If the bug is real, we add 1 coin and 1 Master Pack after we check it.',
    thanksCoin: 'Thanks. We gave you 1 coin.',
    thanksCoinDone: 'Thanks. Today\'s coin is already on your account.',
    rate: 'You already sent several notes today. Try again tomorrow.',
    error: 'Could not send. Write a bit more and try again.',
  },
  lobby: {
    title: 'Online Lobby',
    quickMatch: 'Quick Match',
    queueWaiting: '{n} in queue',
    queueClosed: 'Ranked is paused. Try again in a few minutes.',
    rankedOffer: 'Play one and get {n} coins.',
    rankedHint: 'Ranked. Your league is on your profile.',
    casual: 'Casual queue',
    casualHint: 'Your league does not change.',
    eventHint: 'Weekly event. 7 coins for a win, 5 for a finished loss or draw, the same as ranked. Your league does not change. When the week ends, Master Packs go by percent: 20 for the top 1%, 15 for the rest of the top 10%, 8 for the rest of the top 25%, 4 for the rest of the top 50%, and 2 for the rest.',
    privateRooms: 'Private rooms',
    privateHint: 'Not ranked. Open rooms wait for a second duelist.',
    watch: 'Watch duels',
    watchHint: 'Live PvP. You see the field, not the hands.',
    back: '← Back',
    using: 'Using: {name}',
    playDeck: 'Duel with',
    deckNotReady: ' (not ready)',
    edit: 'Edit',
    buildDeck: 'Build a deck',
  },
  rooms: {
    title: 'Private rooms',
    lead: 'Not ranked. Create a room or join one that is waiting.',
    create: 'Create a room',
    join: 'Join',
    joinCode: 'Join with a code',
    codePlaceholder: 'CODE',
    empty: 'No rooms waiting. Create one, or ask a friend for their code.',
    seats: '{taken}/{max}',
    back: '← Lobby',
    connecting: 'Loading rooms…',
    error: 'Could not reach the server. Check your connection.',
    badCode: 'Enter the 4-character room code.',
    yours: 'Yours',
  },
  watch: {
    title: 'Watch duels',
    lead: 'Live ranked matches and private rooms. Hands and face-down cards stay hidden.',
    filter: 'Show',
    all: 'All',
    ranked: 'Ranked',
    event: 'Event',
    casual: 'Private rooms',
    empty: 'No duels in progress.',
    connecting: 'Loading duels…',
    error: 'Could not reach the server. Check your connection.',
    watch: 'Watch',
    yours: 'Your duel',
    back: '← Home',
    hand: 'Hand',
    deck: 'Deck',
    modeRanked: 'Ranked',
    modeEvent: 'Event',
    modeCasual: 'Private room',
    offline: 'offline',
  },
  packs: {
    title: 'Packs',
    yours: 'Your packs',
    empty: 'You have no unopened packs. Buy one from the shop or start as a new player.',
    shop: 'Shop',
    shopNote: 'Win duels or finish daily missions to earn coins. A shop pack costs:',
    open: 'Open',
    opening: 'Opening…',
    openFailed: 'The pack did not open. Try again.',
    openThree: 'Open 3',
    openFive: 'Open 5',
    openTen: 'Open 10',
    openAnother: 'Open another',
    packOf: 'Pack {n} / {total}',
    nextPack: 'Next pack',
    tapNextPack: 'Tap to open the next pack',
    claim: 'Claim pack',
    buy: 'Buy pack',
    buyThree: 'Buy 3',
    buyFive: 'Buy 5',
    buyTen: 'Buy 10',
    buying: 'Buying…',
    buyFailed: 'The pack was not bought. Try again.',
    buyNeedCoins: 'Not enough coins.',
    buyRate: 'Too many purchases. Wait a moment and try again.',
    buySignedOut: 'Sign in again to buy a pack.',
    boughtOne: '+1 pack',
    boughtMany: '+{n} packs',
    price: '{n} coins',
    have: 'You have x{count}',
    complete: '{percent}%',
    completeOf: '{owned} / {total}',
    completeAria: '{percent} percent. {owned} of {total} cards',
    contents: 'Cards',
    contentsProgress: '{owned} / {total} · {percent}%',
    haveCard: 'You have this card',
    contentsSearch: 'Search a card',
    contentsCount: '{n} cards',
    contentsEmpty: 'No card matches.',
    contentsChase:
      'An Ultra or Secret can also come out Ghost, Helios, Nightglass, or Stormwake.',
    contentsMaster: 'Any card in the game. Each copy rolls its own foil.',
    collection: 'Collection',
    vaultLabel: 'Kaiba Corp',
    binderLabel: 'Collection',
    tagline: {
      'starter-beasts': 'Starter · 20 monsters · Blue-Eyes',
      'starter-runes': 'Starter · 20 spells and traps · Swords',
      'starter-crucible': 'Starter · 5 Extra Deck · Gaia',
      'shop-onyx': 'Special · 5 cards from the whole set',
      'set-lob': '9 cards · Legend of Blue-Eyes and the starter decks',
      'promo-lob': 'Promo · 1 Blue-Eyes White Dragon',
      'set-mrd': '9 cards · Metal Raiders',
      'promo-mrd': 'Special · 5 Metal Raiders cards · Ultra Rare or higher',
      'set-mrl': '9 cards · Magic Ruler',
    },
    names: {
      'starter-beasts': 'Legend of Blue Eyes White Dragon',
      'starter-runes': 'Swords of Light',
      'starter-crucible': 'Gaia the Dragon Champion',
      'set-lob': 'Legend of Blue Eyes White Dragon',
      'promo-lob': 'Promo Pack',
      'set-mrd': 'Metal Raiders Pack',
      'promo-mrd': 'Metal Raiders Special Pack',
      'set-mrl': 'Magic Ruler Pack',
    },
    rarity: {
      common: 'Common',
      rare: 'Rare',
      super: 'Super Rare',
      ultra: 'Ultra Rare',
      ghost: 'Ghost Rare',
      secret: 'Secret Rare',
      helios: 'Helios Rare',
      nightglass: 'Nightglass Rare',
      stormwake: 'Stormwake Rare',
    },
    sfxOn: 'Sound on',
    sfxOff: 'Sound off',
    skip: 'Skip',
    tearHint: 'Grab the pack and swipe to open it',
    openBtn: 'Open',
    new: 'New',
    tapReveal: 'Tap to reveal',
    tapLast: 'The last one… tap to reveal',
    tapNext: 'Tap for the next card',
    tapSummary: 'Tap to see the summary',
    done: 'Done',
    toDeck: 'Go to deck',
  },
  collection: {
    kicker: 'Album',
    title: 'Collection',
    lead: 'One slot per card. LOB first, then Starter Deck: Yugi and Kaiba.',
    openPacks: 'Open packs',
    search: 'Search name or LOB / SDY / SDK…',
    filter: 'Show',
    all: 'All',
    owned: 'Owned',
    missing: 'Missing',
    setFilter: 'Set',
    setAll: 'All sets',
    progress: '{owned} of {total} cards',
    emptyFilter: 'No cards match these filters.',
    loading: 'Loading collection…',
    preferredFoil: 'Preferred rarity',
    slotEmpty: 'This slot is empty. You do not own this card yet.',
    searchFilters: 'Search and filters',
    applyFilters: 'Apply',
    resetFilters: 'Reset filters',
    clearSearch: 'Clear search',
  },
  welcome: {
    kicker: 'Welcome',
    title: 'Your first packs',
    lead:
      'You start with three starter packs and three Master Packs (five ' +
      'cards each). Open them, build a 40-card deck, then you can duel. If ' +
      'you clear this browser’s storage, you become a new player again.',
    cta: 'See my packs',
  },
  needDeck: {
    title: 'Build a 40-card deck',
    body: 'Duels use only cards you pulled from packs. Open your packs and save a Main Deck of at least 40 cards.',
    toPacks: 'Go to packs',
    deckBuilder: 'Deck Builder',
  },
  deck: {
    title: 'Deck Builder',
    backHome: '← Back to Home',
    collection: 'Card Collection',
    tabCollection: 'Collection',
    tabTrunk: 'Trunk',
    tabDeck: 'Deck',
    showTrunk: 'Show trunk',
    showDeck: 'Show deck',
    ownedOnly: 'Only cards pulled from packs.',
    openPacks: 'Open packs',
    search: 'Search cards...',
    clearSearch: 'Clear search',
    searchFilters: 'Search and filters',
    applyFilters: 'Apply',
    allTypes: 'All Types',
    allMonsters: 'All Monsters',
    spell: 'Spell',
    trap: 'Trap',
    allAttributes: 'All Attributes',
    allLevels: 'All Levels',
    allRaces: 'All Races',
    allSubtypes: 'All Subtypes',
    allRarities: 'All Rarities',
    allSets: 'All Sets',
    availabilityAll: 'All',
    availabilityFree: 'Copies left',
    availabilityNotInDeck: 'Not in deck',
    sortBy: 'Sort by',
    sortNameAsc: 'Name A–Z',
    sortNameDesc: 'Name Z–A',
    sortAcquiredDesc: 'Obtained (newest)',
    sortAcquiredAsc: 'Obtained (oldest)',
    sortLevelDesc: 'Level (high)',
    sortLevelAsc: 'Level (low)',
    sortAtkDesc: 'ATK (high)',
    sortAtkAsc: 'ATK (low)',
    sortDefDesc: 'DEF (high)',
    sortDefAsc: 'DEF (low)',
    sortType: 'Type',
    sortRarity: 'Rarity',
    sortSet: 'Set (LOB first)',
    resetFilters: 'Reset filters',
    moreFilters: 'More filters',
    fewerFilters: 'Hide filters',
    emptyCollection: 'You have no cards yet.',
    openForCards: 'Open packs to get cards',
    currentDeck: 'Current Deck',
    min40: 'Min: 40',
    autoBuild: 'Auto-build',
    autoNeed: 'You need 40 Main Deck cards. You have {n}.',
    autoHint: 'Follows the banlist. 20 monsters + 20 spells/traps, highest win rate this season first.',
    sort: 'Sort',
    bestFoils: 'Best rarities',
    bestFoilsHint: 'Puts your rarest copies of each card in the deck.',
    undo: 'Undo',
    undoHint: 'Undo the last change in this deck. Ctrl+Z.',
    undoNamed: 'Undo {name}',
    undoRestoreHint: 'Put {name} back in the deck. Ctrl+Z.',
    undoRestored: '{name} is back in the deck',
    undoDone: 'Undid the last change',
    clear: 'Clear Deck',
    monsters: 'Monsters',
    spells: 'Spells',
    traps: 'Traps',
    emptyMain: 'Your deck is empty',
    emptyMainHint: 'Tap to add one copy. Hold to add up to 3.',
    pvpLimitBadge: 'Max {n}',
    banlistKicker: 'Metal Raiders',
    banlistTitle: 'Banlist',
    banlistLead:
      'These cards exceed the copy limit. Cut them to the max below, then try again.',
    banlistRow: 'you have {have} / max {max}',
    banlistClose: 'Close',
    banlistEdit: 'Edit deck',
    extraDeck: 'Extra Deck',
    emptyExtra: 'No fusion monsters in Extra Deck',
    addCopy: 'Add to deck',
    removeCopy: 'Remove from deck',
    sheetAdd: 'Add',
    sheetRemove: 'Remove',
    copyFoil: 'Rarity of this copy',
    deckName: 'Deck name...',
    save: 'Save Deck',
    saved: 'Saved!',
    addMore: 'Add {n} more cards',
    defaultName: 'My Yu-Gi-Oh Deck',
    myDeck: 'My deck',
    buildForty: 'Build a 40-card deck',
    savedOk: 'Saved “{name}”.',
    savedOkActive:
      'Saved. Duels vs AI and online will use “{name}”. The AI uses a Standard deck.',
    savedOther:
      'Saved “{name}”. Duels still use “{active}”. Choose Use in duels to switch.',
    savedUnowned:
      'Saved, but some copies are not in your collection. Remove them or open more packs before you can duel.',
    savedIllegal:
      'Saved, but this list is not legal (40–60 Main, max 3 copies, Fusions only in Extra). Fix it to duel.',
    savedDraft:
      'Saved. You can keep editing. Duels need 40–60 Main Deck cards you own.',
    hintUnsaved: 'Unsaved changes. Duels still use “{name}” until you save.',
    hintEmpty: 'Save whenever you want. Duels need 40 Main Deck cards you own.',
    hintUnowned:
      'This saved list uses cards you do not own, so duels will not start.',
    hintIllegal: 'This saved list is not legal, so duels will not start.',
    hintEditingOther:
      'Editing “{edit}”. Duels still use “{active}” until you switch.',
    newDeckCard: 'New deck',
    openDeck: 'Edit this deck',
    backToDecks: '← Your decks',
    savedDecks: 'Your decks',
    newDeck: 'New',
    duplicate: 'Duplicate',
    deleteDeck: 'Delete',
    useInDuels: 'Use in duels',
    inDuels: 'In duels',
    tournamentLock: 'In the tournament',
    tournamentLocked:
      'This deck is in the tournament. You cannot edit or delete it until the tournament ends or you leave sign-up.',
    deckLimit: 'You can save up to 10 decks.',
    confirmDelete: 'Delete “{name}”?',
    confirmDiscard: 'Discard unsaved changes?',
    copySuffix: '{name} copy',
    useNeedLegal:
      'This list must be legal and owned (40–60 Main) before it can go to a duel.',
    addedCopies: 'Added {n} to the deck',
    holdToAddThree: 'Click to add 1. Hold to add up to 3.',
    deckList: 'Deck list',
    deckListHint: 'Full deck on one screen, ready to screenshot.',
    deckListShare: 'Share',
    deckListCopied: 'Copied',
    deckListView: 'List view',
    deckListNames: 'Names',
    deckListSprites: 'Cards',
    deckListImage: 'Image',
    deckListImageBusy: 'Saving…',
    deckListImageFail: 'Could not save',
    deckListMain: 'Main {n}',
    deckListExtra: 'Extra {n}',
    recycle: 'Recycle copies',
  },
  recycle: {
    kicker: 'Decks',
    title: 'Recycle copies',
    back: '← Your decks',
    empty: 'You have no extra copies. A card shows up here once you own more than 3.',
    rowCoins: '{n} coins',
    summary: '{n} copies · {coins} coins',
    selectAll: 'Select all',
    clear: 'Clear selection',
    selectScope: 'Applies to',
    lowerRarity: 'Lower rarity',
    higherRarity: 'Higher rarity',
    selectHint: 'Selects every extra copy, starting with this rarity. Three of each card stay.',
    confirm: 'Recycle',
    busy: 'Recycling…',
    done: 'You received {n} coins.',
    failed: 'Could not recycle. Try again.',
    tournamentBlocked:
      'You cannot recycle while you are signed up for the tournament. It opens again when the tournament ends, or if you leave sign-up.',
  },
  duel: {
    you: 'YOU',
    opponent: 'OPPONENT',
    trap: 'Trap',
    field: 'FIELD',
    chainBanner: 'Chain',
    turn: 'Turn {n}',
    yourTurn: 'Your Turn',
    opponentTurn: "Opponent's Turn",
    youParen: '(You)',
    opponentParen: '(Opponent)',
    phaseBanner: {
      draw: 'Draw Phase',
      standby: 'Standby Phase',
      main1: 'Main Phase 1',
      battle: 'Battle Phase',
      main2: 'Main Phase 2',
      end: 'End Phase',
    },
    dice: {
      kicker: 'First player',
      title: 'Roll for first',
      hint: 'Highest roll takes the first turn.',
      roll: 'Roll',
      rolling: 'Rolling…',
      tie: 'Tie! Rolling again…',
      youFirst: 'You go first.',
      oppFirst: 'Opponent goes first.',
      youFirstBig: 'You go first!',
      namedFirst: '{name} goes first!',
      cpu: 'CPU',
    },
    vs: {
      kicker: 'Duel start',
      skip: 'Skip',
    },
    roster: {
      kicker: 'Duelists',
      you: 'You',
      rival: 'Rival',
      placement: 'Placement',
      placementLeft: '{n} duels left',
      noRank: 'Unranked',
      level: 'Level {n}',
      placeRanked: 'Ranked #{n}',
      placeLevel: 'Level ladder #{n}',
      placeAi: '{name} #{n}',
      record: '{wins}–{losses}',
      recordDraws: '{wins}–{losses}–{draws}',
      noDuels: 'No duels yet',
      winStreak: '{n} win streak',
      lossStreak: '{n} loss streak',
    },
    soundOn: 'Sound on',
    soundOff: 'Sound off',
    animSpeed1: 'Anim: Slow',
    animSpeed2: 'Anim: Normal',
    animSpeed3: 'Anim: Fast',
    chat: {
      title: 'Chat',
      placeholder: 'Message...',
      send: 'Send',
      show: 'Chat',
      hide: 'Hide chat',
    },
    roomCode: 'Room code:',
    back: 'Back',
    backHome: 'Back to home',
    surrender: 'Surrender',
    surrenderConfirm: 'Surrender this duel? You will not earn coins or XP.',
    leaveConfirm: 'Leave this duel? It ends now and your opponent wins.',
    tournamentLeaveConfirm: 'If you leave the room, you lose this match.',
    tournamentLeave: 'Leave and lose',
    tournamentStay: 'Stay',
    surrenderCancel: 'Keep playing',
    rankedCall: '{name} is waiting for a ranked duel.',
    rankedCallWait: 'Waiting for a ranked duel.',
    rankedCallGo: 'Duel',
    rankedCallGoPay: 'Duel {name} for {n} coins',
    rankedCallGoHint: 'Leave this duel and play ranked against {name}. Finish it to collect the coins.',
    rankedCallIgnore: 'Ignore',
    viewerCard: 'Card',
    viewerSettings: 'Settings',
    viewerLog: 'Log',
    viewerEmpty: 'Tap a card to see it here.',
    viewerFaceDown: 'Face-down card.',
    hideViewer: 'Hide card info',
    showViewer: 'Show card info',
    gear: 'Duel settings',
    focusCycle: 'Cycle the field view',
    shuffleHand: 'Shuffle hand',
    nextPhase: 'Next',
    holdToEndTurn: 'Hold to end the turn (skip Battle and Main 2)',
    response: {
      title: 'Traps',
      auto: 'Auto',
      always: 'All',
      minimal: 'Minimal',
      off: 'Off',
      hint: 'When the game asks if you want to activate a trap. Tap to cycle All, Auto, Minimal, Off.',
    },
    connecting: 'Connecting...',
    reconnecting: 'Connection dropped. Reconnecting…',
    opponentReconnecting: 'Your opponent lost connection. They have one minute to return.',
    watching: 'Watching the duel',
    spectators: 'Watching',
    spectatorsCount: '{n} watching',
    replay: {
      kicker: 'Replay',
      play: 'Play',
      pause: 'Pause',
      step: 'Step',
      speed: '{n}×',
      speedLabel: 'Speed {n}×',
      collapse: 'Collapse controls',
      expand: 'Expand controls',
      move: 'Drag to move',
      loading: 'Loading replay…',
      missing: 'This replay is no longer available.',
      stale: 'This replay cannot be played on the current rules.',
    },
    watchWaiting: 'Waiting on {name}',
    watchWinner: '{name} won',
    watchDraw: 'The duel ended',
    watchBack: 'Back to the panel',
    watchBackList: 'Back to the list',
    watchOver: {
      lifePoints: "A player's Life Points reached 0.",
      deckOut: 'A player could not draw a card.',
      exodia: 'A player assembled all five pieces of Exodia.',
      surrender: 'A player surrendered.',
      forfeit: 'A player left the room.',
      timeout: "A player's clock ran out.",
      roundTime: 'The round ran out of time.',
    },
    creating: 'Creating room...',
    joining: 'Joining room...',
    searching: 'Searching for an opponent...',
    tournamentWait: 'Waiting for your tournament match...',
    tournamentWaitFor: 'Waiting for {name}',
    tournamentAdvance: 'You move on.',
    tournamentTimeUp: 'Time is up.',
    searchingCasual: 'Searching for a casual duel. Your league does not change.',
    searchingEvent: 'Searching for an event duel. Your league does not change.',
    searchingElapsed: 'Time in queue: {time}',
    searchingStill: 'Still looking. The queue is active.',
    queueWindowNear: 'Close to your rating (±{n})',
    queueWindowMid: 'A wider search (±{n})',
    queueWindowOpen: 'Anyone waiting in the queue',
    queueWidenIn: 'Widens in {n}s',
    queueOpenIn: 'Opens to anyone in {n}s',
    queueStar: 'Tap the star',
    queueStarBonus: 'Small star',
    queueStarCount: '{n} stars',
    queueStarBest: 'Best: {n}',
    queueStarCoin: 'A coin!',
    queueRun: 'Tap to jump',
    queueRunOver: 'Tap to go again',
    queueRunCount: '{n} steps',
    waitingJoin: 'Waiting for opponent to join...',
    victory: 'VICTORY',
    defeat: 'DEFEAT',
    victorySub: 'You won the duel!',
    defeatSub: 'Your opponent has defeated you.',
    overBy: {
      lifePointsWin: 'The opponent’s Life Points reached 0.',
      lifePointsLose: 'Your Life Points reached 0.',
      deckOutWin: 'The opponent could not draw a card.',
      deckOutLose: 'You could not draw a card.',
      exodiaWin: 'You assembled all five pieces of Exodia in your hand.',
      exodiaLose: 'The opponent assembled all five pieces of Exodia.',
      surrenderWin: 'The opponent surrendered.',
      surrenderLose: 'You surrendered.',
      forfeitWin: 'The opponent left the room.',
      forfeitLose: 'You left the room.',
      timeoutWin: 'The opponent ran out of time.',
      timeoutLose: 'You ran out of time.',
      roundTimeWin: 'The round ran out of time.',
      roundTimeLose: 'The round ran out of time.',
      aiTooLong: 'This duel reached one hour, so it ended. No coins or XP.',
      aiEnded: 'This duel was ended. No coins or XP.',
    },
    clockHint: 'Time you have left. At zero you lose. A turn change adds more.',
    exodia: {
      kicker: 'The forbidden one',
      sub: 'All five pieces, in hand',
      skip: 'Tap to skip',
    },
    reward: '+{n} coins',
    rankedNudgePaid: 'Includes {n} coins for playing ranked.',
    rankedOffer: 'Play a ranked match and we give you {n} coins.',
    rankedOfferGo: 'Play ranked',
    playAgain: 'Play Again',
    tournamentPrizes: 'You will get the prizes in your mailbox at the end of the tournament.',
    returnLobby: 'Return to Lobby',
    youWin: 'YOU WIN!',
    youLose: 'YOU LOSE',
    gameOver: 'GAME OVER',
    backToMenu: 'Back to Menu',
    extraYours: 'Your Extra Deck',
    extraOpp: "Opponent's Extra Deck",
    banishedYours: 'Your Banished Cards',
    banishedOpp: "Opponent's Banished Cards",
    gyYours: 'Your Graveyard',
    gyOpp: "Opponent's Graveyard",
    log: {
      empty: 'Duel actions will show up here.',
      aCard: 'a card',
      turn: 'Turn {n} — {name}',
      phase: '{name} — {phase}',
      draw: '{name} drew {card}',
      drawHidden: '{name} drew a card',
      summon: '{name} Normal Summoned {card}',
      tributeSummon: '{name} Tribute Summoned {card}',
      set: '{name} Set a card',
      flip: '{card} was flipped face-up',
      posAtk: '{card} switched to Attack Position',
      posDef: '{card} switched to Defense Position',
      spell: '{name} activated {card}',
      trap: '{name} activated {card}',
      effect: '{card}: effect activated',
      attack: '{card} attacks {target}',
      attackDirect: '{card} attacks directly',
      replay: '{card}: a Replay — choose a new attack or pass',
      destroy: '{card} was destroyed',
      banish: '{card} was banished',
      toHand: '{card} returned to the hand',
      lp: '{name}: {lp} LP ({delta})',
      gameOver: '{name} wins',
      message: '{text}',
    },
    gyCount: '{n} cards',
    menu: {
      tributeAtk: 'Tribute Summon (ATK)',
      tributeSet: 'Tribute Set',
      asTribute: 'Select as Tribute',
      undoTribute: 'Remove Tribute',
      normalAtk: 'Normal Summon (ATK)',
      setMonster: 'Set (face-down DEF)',
      activate: 'Activate',
      set: 'Set',
      flipSummon: 'Flip Summon',
      changePosition: 'Change Position',
      attackDirect: 'Attack directly',
      attackThis: 'Attack {name}',
      attackFaceDown: 'Attack the face-down monster',
      attackPick: 'Attack a monster',
      equip: 'Equip',
      specialAtk: 'Special Summon (ATK)',
      specialDef: 'Special Summon (DEF)',
    },
    picker: {
      special: 'Special Summon which monster?',
      fusion: 'Fusion Summon which monster?',
      banishGy: 'Banish 1 or 2 monsters from the opponent GY',
      lastWill: 'Special Summon from the Deck? Cancel keeps it for later this turn.',
      fromCard: 'Effect of {card}',
      flute: 'Special Summon up to 2 Dragons from your hand',
      egotist: 'Special Summon Harpie Lady or Harpie Lady Sisters',
      fromHand: 'Hand',
      fromDeck: 'Deck',
      spy: 'Look at 1 card in the opponent’s hand',
      peek: 'You looked at these cards',
      bigEye: 'Put them back. The first card you choose is the top of your Deck.',
      peekReveal: 'The Stern Mystic revealed these cards',
      peekSearch: 'Added to the hand',
      sangan: 'Add 1 monster with 1500 or less ATK from your Deck',
      witch: 'Add 1 monster with 1500 or less DEF from your Deck',
      thunderDragon: 'Add Thunder Dragon from your Deck',
      searchDeck: 'Add a card from your Deck',
      yours: 'Yours',
      opp: 'Opponent',
      ownerHand: 'If it returns to the hand, it goes back to its owner.',
      gyEmpty: 'Empty',
      confirm: 'Confirm',
      close: 'Close',
      cancel: '✕ cancel',
      selectExact: 'Select {n}',
      selectRange: 'Select {min}–{max}',
      chainOrder: 'Chain order. The first card you pick resolves last.',
      chainSearch: 'Searches the Deck',
      chainSword: 'Returns to the Deck',
      chainLife: 'You lose Life Points',
      chainDiscard: 'Opponent discards',
      chainDraw: 'You draw 1',
      chainDrawOpp: 'Opponent draws 2',
      doomedDiscard: 'Discard 1 card',
      blastJuggler: 'Destroy 2 face-up monsters with 1000 or less ATK',
      coffin: 'Discard 1 to 3 monsters from your hand',
      gySpell: 'Add 1 Spell from your Graveyard to your hand',
      gyTrap: 'Add 1 Trap from your Graveyard to your hand',
      magicJammer: 'Discard 1 card to negate that Spell',
      soulRelease: 'Banish up to 5 cards from either Graveyard',
      yadoBottom: 'Put cards on the bottom of your Deck. The last one you pick is the bottom.',
    },
    coin: {
      heads: 'Heads',
      tails: 'Tails',
      close: 'Close',
    },
    prompt: {
      cancel: '✕ cancel',
      pass: 'No, pass',
      activate: 'Activate {name}',
      offeringIgnite: 'Ultimate Offering: pay 500 LP to Normal Summon or Set?',
      offeringPayBtn: 'Pay 500 LP: {name}',
      offeringPayAction: 'Pay 500 LP',
      trapOnSummon: 'Activate a Trap in response to the summon?',
      trapOnAttack: 'Activate a Trap in response to the attack?',
      trapOnDamage: 'Activate a Trap before damage calculation?',
      chainTo: 'Chain to {name}?',
      trapActivate: 'Activate a Trap?',
      discard: 'Over the hand limit — discard {n} card(s): click cards in your hand',
      waitingDiscard: 'Waiting for opponent to discard…',
      flipTarget: '{name}: choose a target — click a highlighted card',
      selectHighlighted: 'Select the highlighted card',
      selectNamed: 'Select {name}',
      chainOrder: 'Order the chain. The first card resolves last: {names}',
      chainOrderGo: 'Use this order',
      waitingChainOrder: 'Waiting for opponent to order the chain…',
      waitingTarget: 'Waiting for opponent to choose a target…',
      coinCall: '{name}: call the coin toss',
      heads: 'Heads',
      tails: 'Tails',
      waitingCoin: 'Waiting for opponent to call the coin…',
      blastJuggler:
        '{name}: Tribute it to destroy 2 face-up monsters with 1000 or less ATK?',
      mushroomGive: '{name}: pay 500 LP to give control of it to your opponent?',
      choiceYes: 'Yes',
      choiceNo: 'No',
      waitingChoice: 'Your opponent is deciding…',
      waitingRespond: 'Your opponent is deciding…',
      viewingOwnGy: 'Your opponent is looking at their Graveyard…',
      viewingYourGy: 'Your opponent is looking at your Graveyard…',
      viewingOwnGyNamed: '{name} is looking at their Graveyard…',
      viewingOppGyNamed: '{name} is looking at {other}’s Graveyard…',
      waitingOffering: 'Waiting for opponent to Normal Summon or Set…',
      offeringPay:
        'Ultimate Offering: pay 500 LP, then Normal Summon or Set',
      offeringSummon:
        'Ultimate Offering: Normal Summon or Set from your hand',
    },
    position: {
      summon: 'Summon {name} in ATK or Set?',
      select: 'Select position for {name}',
      attack: 'ATTACK',
      defense: 'DEFENSE',
      set: 'SET',
      faceDownDef: 'face-down DEF',
    },
    error: {
      roomGone: 'The duel could not be resumed.',
      queueClosed: 'Ranked is paused. Try again in a few minutes.',
      eventClosed: 'This event queue is closed.',
      eventDeck: 'Your deck does not match this event.',
      deck_banlist: 'Your deck violates the banlist.',
      not_friends: 'That duelist is not on your friend list.',
      friend_offline: 'That friend is offline.',
      friend_in_duel: 'That friend is already in a duel.',
      invalid_username: 'That name is not valid.',
      queueSwitched: 'You joined the other queue.',
      tournamentBusy: 'Finish your tournament match first.',
      waitingTrapResponse: 'Waiting for a trap response',
      discardFirst: 'You must discard down to the hand limit first',
      waitingFlipTarget: 'Waiting for a Flip Effect target selection',
      waitingTarget: 'Waiting for a target selection',
      waitingOffering: 'Waiting for Ultimate Offering',
      offeringSummonOrPass: 'Normal Summon or Set, or pass',
      offeringSummonOwed: 'Ultimate Offering: Normal Summon or Set the monster you paid for',
      notYourTurn: 'Not your turn',
      notMainPhase: 'Not in a Main Phase',
      notBattlePhase: 'Not in the Battle Phase',
      notBattleStep: 'Not in the Battle Step',
      attackResolving: 'An attack is still resolving',
      notNow: "You can't do that right now",
      notNowWaiting: "You can't do that right now — waiting for your opponent",
      skipEndOnly: 'You can only skip ahead to the End Phase',
      cannotSkipEnd: 'Cannot skip to the End Phase from here',
      cardNotInHand: 'Card not in hand',
      notMonster: 'Not a monster',
      fusionNoNormal: 'Fusion monsters cannot be Normal Summoned',
      requiresTribute: 'Requires tribute summon',
      monsterZoneOccupied: 'Monster zone occupied',
      invalidZone: 'Invalid zone',
      fusionNoTribute: 'Fusion monsters cannot be Tribute Summoned',
      noTributesNeeded: 'Does not require tributes',
      needsExactTributes: 'Needs exactly {n} tributes',
      invalidTribute: 'Invalid tribute',
      noFreeMonsterZone: 'No free monster zone',
      noNormalSummon: 'This monster cannot be Normal Summoned or Set',
      monsterNotFound: 'Monster not found',
      noPositionSummonTurn: 'Cannot change position the turn it was summoned',
      positionAlreadyChanged: 'Position already changed this turn',
      monsterAlreadyAttacked: 'Monster already attacked',
      dragonCaptureJar: 'Dragons are locked in Defense Position (Dragon Capture Jar)',
      alreadyFaceUp: 'Already face-up',
      noFlipSetTurn: 'Cannot flip the turn it was set',
      notSpellTrap: 'Not a spell/trap',
      noFreeSpellZone: 'No free spell/trap zone',
      notSpell: 'Not a spell',
      setSpellNotFound: 'Set spell not found',
      setTrapNotFound: 'Set trap not found',
      notTrap: 'Not a trap',
      trapSetDelay: 'A trap cannot be activated the turn it was set',
      noDamageStep: 'This card cannot be activated in the Damage Step',
      cannotActivateNow: 'This card cannot be activated right now',
      conditionsNotMet: 'Activation conditions are not met',
      noLegalTarget: 'No legal target for this card',
      selectValidTargets: 'Select valid targets for this card',
      selectValidTarget: 'Select a valid target for this card',
      noFlipPending: 'No flip selection pending',
      notYourSelection: 'Not your selection',
      invalidTarget: 'Invalid target',
      noTargetPending: 'No target selection pending',
      attackerNotFound: 'Attacker not found',
      targetNotFound: 'Target not found',
      cannotDirectAttack: 'Opponent controls monsters; cannot attack directly',
      attackerFaceDown: 'Attacker is face-down',
      attackerNotAttackPos: 'Attacker not in attack position',
      alreadyAttacked: 'Already attacked this turn',
      noFirstTurnAttack: 'Cannot attack on the very first turn',
      swordsOfRevealingLight: 'You cannot attack (Swords of Revealing Light)',
      targetNotMonster: 'Target is not a monster',
      noPendingResponse: 'No pending response',
      notYourResponse: 'It is not your response to make',
      cardCannotActivateNow: 'That card cannot be activated now',
      chainTooLong: 'Chain is too long',
      cannotChainSlower: 'Cannot chain a slower effect',
      spellSpeed1NoChain: 'Spell Speed 1 cannot be chained',
      noDiscardOwed: 'You do not owe a discard',
      cardNotYourHand: 'That card is not in your hand',
      normalSummonUsed: 'Normal summon already used this turn',
      offeringPhase: "Ultimate Offering: your Main Phase or the opponent's Battle Phase",
      notEnoughLp: 'Not enough Life Points',
      noOfferingMonster: 'No monster you can Normal Summon or Tribute Summon',
      matchNotFound: 'Match not found',
      notInMatch: 'You are not in this match',
      sessionMoved: 'This duel continued on your other device',
      invalidAction: 'Invalid action',
      spectateDenied: 'That duel cannot be watched',
      internalError: 'Internal error',
    },
    msg: {
      offeringPassed: '{name}: passed.',
      offeringAgain: '{name}: you may Normal Summon or Set again.',
      unsupportedAction: 'Action not supported by engine yet',
      discardDown: 'Discard {n} card(s) down to {limit}.',
      flipActivated: '{name}: Flip Effect activated!',
      flipNoTarget: '{name}: Flip Effect — no valid target',
      attackCancelled: 'The attack was cancelled: {reason}.',
      attackCancelAttacker: 'the attacker can no longer attack',
      attackCancelTarget: 'the target left the field',
      attackCancelOpp: 'the opponent now controls a monster',
      wabokuDamage: '{name}: battle damage becomes 0.',
      kuribohDamage: '{name}: this attack deals 0 battle damage.',
      wabokuAttacker: '{name}: the attacking monster is not destroyed by battle this turn.',
      wabokuDefender: '{name}: the defending monster is not destroyed by battle this turn.',
      noResponse: 'No response.',
      fizzled: '{name} fizzled (its targets are no longer legal).',
      egotistNoLady: '{name}: there is no face-up Harpie Lady on the field.',
      egotistNoZone: '{name}: no free monster zone.',
      egotistNoMonster:
        '{name}: no Harpie Lady or Harpie Lady Sisters in your hand or Deck.',
      noLegalTarget: '{name}: no legal target.',
      reverseTrap: '{name}: ATK and DEF modifiers are inverted until the End Phase.',
      bigEye: '{name}: {n} card(s) returned to the top of the Deck.',
      shieldSword: '{name}: original ATK and DEF are switched until the end of this turn.',
      returnedToExtra: '{name} returned to the Extra Deck.',
      revealDestroyed: '{name} was a {kind} — destroyed.',
      revealSetAgain: '{name} was a {kind} — Set again (not destroyed).',
      kindTrap: 'Trap',
      kindSpell: 'Spell',
      barrelHit: '{name}: {heads} heads. That monster is destroyed.',
      barrelMiss: '{name}: {heads} heads. Nothing is destroyed.',
      coinCall: '{name}: call Heads or Tails.',
    },
    toast: {
      flipFirst: 'Choose a target for the Flip Effect first',
      mainPhaseOnly: 'You can only play from your hand during your Main Phase',
      offeringPayFirst: 'Pay 500 LP first',
      notEnoughTribute: 'Not enough monsters to tribute',
      noMonsterZone: 'No free monster zone',
      noSpellZone: 'No free spell/trap zone',
      notEnoughField: 'Not enough monsters on the field for this card',
      noValidTarget: 'No valid target for this card',
      equipNeedsRace: 'Equip it to a face-up {race} monster',
      equipNeedsAttr: 'Equip it to a face-up {attr} monster',
      equipNotRace: 'You cannot equip it to a {race} monster',
      equipNeedsMonster: 'Equip it to a face-up monster',
      selectTarget: 'Select a target',
      fissureTie: 'Fissure: the lowest ATK is tied. Choose which monster to destroy.',
      cancelled: 'Activation cancelled',
      highlighted: 'Choose one of the highlighted cards',
      mustChooseTarget: 'This card is already activated — choose a target',
      sistersEgotist:
        'Harpie Lady Sisters is Special Summoned by Elegant Egotist, from your hand or Deck. Tap it in that list, then choose Attack or Defense.',
      invalidTarget: 'That card is not a valid target for this card',
      selectTribute: 'Select {need} monster(s) to tribute ({selected}/{need})',
      clickOwnTribute: 'Click your own monsters to tribute',
      soulExchangeNoZone:
        'Soul Exchange does not free a monster zone. Tribute one of yours, or leave a zone empty.',
      invalidStep: 'That monster is not a valid choice for this step',
      selectAttack: 'Select an enemy monster to attack',
      replay: 'Replay — choose a new attack or pass',
      skipBattle: 'You cannot enter the Battle Phase this turn',
      escCancel: ' — Esc to cancel',
      destroyYours: 'Choose 2 of your own monsters to destroy',
      destroyOpp: "Choose the opponent's monster to destroy",
      cocoonNeeds: 'Equip it to a face-up Petit Moth',
      cocoonPick: 'Choose a face-up Petit Moth',
      gateNeeds: 'You need Sanga of the Thunder, Kazejin, and Suijin on your field',
      gateTributes: 'Tribute Sanga of the Thunder, Kazejin, and Suijin',
      larvaeNeeds: 'Petit Moth with Cocoon of Evolution, on your 2nd turn',
      greatNeeds: 'Petit Moth with Cocoon of Evolution, on your 4th turn',
    },
  },
  ops: {
    kicker: 'Internal',
    title: 'Ops',
    lead: 'Accounts, the queue, live duels, ranked matches, cards, collection copies, mailbox, chat, and the collection poll.',
    home: 'Home',
    keyLabel: 'Admin key',
    keyError: 'That key does not open this page.',
    unlock: 'Unlock',
    loadError: 'Could not load this view.',
    empty: 'Nothing here yet.',
    search: 'Search',
    searchUsers: 'Username or email',
    filterActivity: 'Activity',
    filterAll: 'All',
    filterDay: 'Active today',
    filterWeek: 'Active this week',
    filterNew: 'New this week',
    filterIdle: 'Inactive (7 days)',
    filterRole: 'Type',
    filterAdmins: 'Admins',
    filterPlayers: 'Players',
    filterSort: 'Sort',
    sortNewest: 'Newest',
    sortSeen: 'Last seen',
    sortLevel: 'Level',
    sortCoins: 'Coins',
    sortDuels: 'Duels',
    sortCollection: 'Collection',
    sortRanked: 'Ranked',
    adminBadge: 'Admin',
    portrait: {
      title: 'Exclusive portrait',
      lead: 'Only your account can wear it. Other duelists see it in duels and in chat.',
      upload: 'Upload image',
      uploading: 'Uploading…',
      uploadLead:
        'Pick an image from this computer. Uploading it makes that image your portrait.',
      wear: 'Wear this portrait',
      wearing: 'You are wearing it',
      error: 'Could not save the portrait.',
      uploadError: 'Could not save that image.',
      badType: 'That file is not an image this page can use.',
    },
    userCount: '{n} accounts',
    deleteUser: 'Delete account',
    deleteLead: 'Deletes the account, decks, album, and history. This cannot be undone.',
    deleteAdminWarn: 'This account is also an admin.',
    deleteType: 'Type {name} to confirm',
    deleteConfirm: 'Delete',
    deleteCancel: 'Cancel',
    deleteError: 'Could not delete the account.',
    deleteMismatch: 'The username does not match.',
    deleteSelf: 'You cannot delete your own account.',
    masterPacks: 'Master Packs',
    rewardTitle: 'Send a reward',
    rewardLead:
      'The player gets this message in their mailbox and claims the coins or Master Packs there.',
    rewardMessage: 'Message',
    rewardPlaceholder: 'Write a note for this player',
    rewardDoneMailbox: 'Sent to their mailbox.',
    rewardKind: 'Reward',
    rewardCoins: 'Coins',
    rewardPacks: 'Master Packs',
    rewardQty: 'Amount',
    rewardSend: 'Send',
    rewardSending: 'Sending…',
    rewardError: 'Could not send the reward.',
    rewardDoneCoins: 'Sent. This account now has {n} coins.',
    rewardDonePacks: 'Sent. This account now has {n} Master Packs.',
    backList: 'Back to list',
    prev: 'Previous',
    next: 'Next',
    tabs: {
      overview: 'Overview',
      logs: 'Logs',
      live: 'Live',
      queue: 'Queue',
      users: 'Users',
      duels: 'Duels',
      cards: 'Cards',
      decks: 'Decks',
      pulls: 'Collection',
      ranked: 'Ranked',
      chat: 'Chat',
      feedback: 'Mailbox',
      poll: 'Poll',
      tourneys: 'Tournaments',
      reset: 'Expansion reset',
    },
    maintenance: {
      title: 'Maintenance',
      lead: 'Close the site now. This does not wipe accounts, cards, or run the reset.',
      on: 'Enter maintenance',
      confirmOn: 'Close the site',
      confirmOnHint: 'Everyone sees the notice and live duels disconnect. This admin page stays open.',
      off: 'Open the site',
      confirmOff: 'Open the site',
      confirmOffHint: 'The notice goes away and ranked matchmaking accepts players again.',
      stateFull: 'The site is in maintenance.',
      stateClosed: 'Entry is closed. Full maintenance is not on yet.',
      stateOff: 'The site is open.',
      errors: {
        failed: 'Could not change maintenance.',
        reset_in_progress: 'A reset is in progress. The site opens when that checklist finishes.',
      },
    },
    eventQueue: {
      title: 'Weekly event queue',
      lead: 'One mode at a time, seven days. Finished duels pay 7 coins for a win and 5 for a loss or draw, the same as ranked. Anyone with a win gets one Master Pack band, counted among players with a win: 20 for the top 1%, 15 for the rest of the top 10%, 8 for the rest of the top 25%, 4 for the rest of the top 50%, and 2 for the rest. Ranked and casual stay as they are.',
      none: 'No event is live.',
      live: '{mode} is live until {time}.',
      mode: 'Mode',
      start: 'Start 7 days',
      startConfirm: 'Start',
      startHint: 'Opens this queue for a week. Only one event can be live.',
      end: 'End now',
      endConfirm: 'End and pay',
      endHint: 'Closes the queue and mails Master Packs to everyone with a win.',
      place: '#',
      player: 'Player',
      wins: 'W–L',
      notices: {
        started: 'The event queue is live.',
        ended: 'The event closed and prizes were mailed.',
        none: 'No event was live.',
        event_live: 'An event is already live.',
        failed: 'Could not change the event queue.',
      },
    },
    tournament: {
      title: 'Tournaments',
      lead: 'Automatic tournaments use the seats, the start rule, and the interval below. Pause stops the schedule. Start now does not wait for the next slot. A sign-up that is already open keeps its seats and its time.',
      paused: 'Automatic tournaments are paused.',
      running: 'Automatic tournaments run every {n} minutes.',
      phaseNone: 'No tournament is open.',
      phaseRegistration: 'Sign-up is open. {n} of {max} players. Starts {time}.',
      seats: 'Seats',
      startWhenFull: 'Start when the seats are full',
      interval: 'Minutes between tournaments',
      save: 'Save',
      openKeeps: 'The open sign-up keeps {n} seats.',
      phaseLive: 'A tournament is in progress.',
      pause: 'Pause automatic',
      pauseConfirm: 'Pause',
      pauseHint: 'No automatic tournament will open or start. One already in progress keeps going.',
      resume: 'Resume automatic',
      resumeConfirm: 'Resume',
      resumeHint: 'The schedule returns. A sign-up whose start already passed begins right away.',
      start: 'Open a tournament now',
      startConfirm: 'Open sign-up',
      startHint: 'Sign-up opens now. It starts in 30 minutes, or sooner if you start the bracket. While paused, it does not start by itself.',
      begin: 'Start the bracket',
      beginConfirm: 'Start now',
      beginHint: 'Starts with whoever is signed up. Four players are required. Fewer than that leaves sign-up open.',
      notices: {
        opened: 'Sign-up is open.',
        live: 'The bracket started.',
        need_players: 'Four players are required. Sign-up stays open.',
        live_busy: 'A tournament is already in progress.',
        paused: 'Automatic tournaments are paused.',
        resumed: 'Automatic tournaments are back on the schedule.',
        saved: 'Saved. The next automatic tournament uses these.',
        failed: 'Could not change tournaments.',
      },
    },
    tourneyHistory: {
      lead: 'Tournaments from this server, including ones that already finished. A played duel has Replay on the bracket. A bye does not.',
      live: 'In progress',
    },
    reset: {
      title: 'Expansion reset',
      start: 'Start reset',
      confirm: 'Confirm reset',
      confirmHint: 'This clears copies, coins, level, decks, packs, and the banlist. The album and cosmetics stay.',
      retry: 'Retry',
      running: 'In progress',
      done: 'Reset finished',
      waiting: '{n} duels still going',
      empty: 'No reset is waiting.',
      errors: {
        expansion_not_ready: 'This expansion is not on the server yet.',
        migrations_behind: 'The database is missing migrations.',
        devtools_open: 'Developer tools are not closed.',
        step_out_of_order: 'That step is not next.',
        no_reset: 'No reset is waiting.',
        step_failed: 'The step failed. Retry from here.',
      },
      steps: {
        'expansion-ready': 'Expansion on the server',
        migrations: 'Migrations up to date',
        devtools: 'Developer tools closed',
        'close-entry': 'Entry closed',
        'wait-duels': 'Live duels finished',
        'maintenance-full': 'Full maintenance',
        backup: 'Backup saved',
        'close-season': 'Season closed',
        'save-album': 'Album saved',
        'wipe-copies': 'Copies at zero',
        'wipe-packs': 'Packs reset',
        'wipe-coins': 'Coins at zero',
        'wipe-xp': 'Level at zero',
        'wipe-decks': 'Decks deleted',
        'reset-league': 'League at placement',
        'restore-promos': 'Promos returned',
        'clear-banlist': 'Banlist cleared',
        'grant-rewards': 'Closing rewards delivered',
        'open-season': 'New season open',
        'mail-special': 'Special pack mailed',
        'mark-done': 'Reset marked done',
        'maintenance-off': 'Site open',
      },
    },
    cardsLead:
      'Cards duelists bring when a duel starts, this season. The top bar is usage against the most seen card. The lower bar is the win rate in finished duels.',
    cardsDecks: '{n} decks',
    cardsUsage: 'Usage {n}%',
    cardsWin: 'Wins {n}',
    cardsMinUsage: 'Usage at least',
    cardsMinWin: 'Win rate at least',
    cardsAny: 'Any',
    cardsMatch: '{n} cards',
    cardsBanlist: 'Banlist',
    cardsBanlist1: 'Limited — max 1',
    cardsBanlist2: 'Semi-Limited — max 2',
    cardsBanlistOpen: 'Unrestricted',
    cardsBanlistNot1: 'Not limited to 1',
    cardsCap: 'max {n}',
    cardsAvg: '{n} copies per deck',
    decksLead:
      'Finished duels this season, grouped when the main decks are alike. The Extra Deck is left out. The pictures are the most-played main list in the group. A card in at least 40% of those duels drops out of the name. Across is how often the group is played. Up is the win rate. The upper right is what shows up and wins.',
    decksMain: 'Main deck',
    decksSeason: 'Season',
    decksSeasonOpen: '{name} · now',
    deckSeason: {
      'set-mrd': 'Metal Raiders',
      'set-mrl': 'Magic Ruler',
    },
    decksBracket: 'League',
    decksAllLeagues: 'All leagues',
    decksTop: 'Champion and King',
    decksLoading: 'Loading decks…',
    decksEmpty: 'No lists in this season yet.',
    decksStaples: 'Staples',
    decksPlay: 'Played in {n}% of duels',
    decksWin: 'Win rate {n}',
    decksRecord: '{wins} wins · {losses} losses · {draws} draws',
    decksDuels: '{n} duels',
    decksTrend: 'Last 7 days {recent}% · the 7 days before {prev}%',
    decksTrendRecent: 'Last 7 days {recent}%',
    decksHidden: '{n} groups with fewer than 5 duels are not shown.',
    decksChart: 'Play rate and win rate',
    decksPlayAxis: 'Played',
    decksWinAxis: 'Win rate',
    pullsLead:
      'Copies each player holds right now. The number is how many own it. The bar compares that with the {players} players who have an album. Tap a card to see who has 2 or 3 copies.',
    pullsLoading: 'Loading the collection…',
    pullsSummary:
      '{cards} cards · {none} unowned · {two} at 2 copies · {playset} at 3 copies',
    pullsSortFew: 'Fewest players',
    pullsSortMany: 'Most players',
    pullsSortCatalog: 'Album order',
    pullsAll: 'All',
    pullsTwo: 'At 2',
    pullsThree: 'At 3',
    pullsNone: 'Nobody',
    pullsLegendThree: 'Someone has 3',
    pullsLegendTwo: 'Someone has 2',
    pullsLegendNone: 'Nobody owns it',
    pullsOwners: '{n} of {players}',
    pullsCopies: '{n} copies',
    pullsNobody: 'Nobody has 2 or more copies.',
    pullsPick: 'Tap a card to see the names.',
    pullsTile: '{name}. {n} players, {two} at 2 copies, {three} at 3.',
    pollLead:
      'Votes on forbidden cards now, or only limited cards for the time being. A forbidden card cannot be played: 0 copies.',
    pollForbidden: 'Forbidden cards',
    pollLimited: 'Limited only',
    pollNone: 'No vote',
    pollTally: '{forbidden} forbidden · {limited} limited only',
    pollEmpty: 'No votes yet.',
    bugReal: 'It was real',
    bugDismiss: 'Not a bug',
    bugPending: 'Pending',
    bugPaid: 'Booster paid',
    bugDismissed: 'Dismissed',
    bugReviewError: 'Could not save the review.',
    bugReply: 'Reply',
    bugReplied: 'Replied',
    bugReplyTitle: 'Reply to {name}',
    bugReplyLead:
      'Closes this report. The player gets the message in their mailbox and claims any reward there.',
    bugReplyMessage: 'Message',
    bugReplyCoins: 'Coins',
    bugReplyPacks: 'Master Packs',
    bugReplyHint: 'Use 0 when you do not want that reward.',
    bugReplySend: 'Send and close',
    bugReplySending: 'Sending…',
    bugReplyCancel: 'Cancel',
    bugReplyError: 'Could not send the reply.',
    devices: 'Devices',
    deviceNone: 'No device saved yet.',
    deviceUnknown: 'Unknown',
    deviceInstalled: 'Installed app',
    deviceBrowser: 'Browser',
    deviceFullscreen: 'Full screen',
    deviceTouch: 'Touch',
    devicePointer: 'Pointer',
    deviceLock: 'Landscape lock',
    deviceNoLock: 'No landscape lock',
    liveLead:
      'Duels in progress. This list updates on its own. PvP duels can be opened on the board. Vs AI duels can be ended here, and they end on their own after one hour.',
    watch: 'Watch',
    liveFilter: 'Show',
    liveAll: 'All',
    liveAi: 'Vs AI',
    livePvp: 'PvP',
    modeAi: 'Vs AI',
    modeCasual: 'Casual',
    modeRanked: 'Ranked',
    modeEvent: 'Event',
    liveHand: 'hand',
    liveDeck: 'deck',
    offline: 'disconnected',
    liveEmpty: 'Nobody is in a duel right now.',
    queueLead:
      'Accounts waiting for Quick Match. Two pair when the rating gap fits the window of whoever has waited less. It starts at ±{start}, widens to ±{mid} after {midWait}s, and opens after {openWait}s. With fewer than {pool} ranked accounts this week, the window stays open. This list updates on its own.',
    queueEmpty: 'Nobody is in the queue.',
    queueGate: 'Quick Match',
    queueGateOn: 'Open. Duelists can enter the queue.',
    queueGateOff:
      'Closed. Nobody new can start a ranked duel. People already waiting are sent home. Duels in progress keep going. The queue opens again when this server restarts.',
    queueGateError: 'Could not change the queue.',
    queueCount: '{n} waiting',
    queuePairReady: 'A pair fits. The server checks every 5 seconds.',
    queuePairBlocked: '{n} waiting, and none are close enough yet.',
    queueSmallPool: 'Few ranked accounts this week ({n}). The window stays open.',
    queueNormalPool: 'Ranked accounts this week: {n}.',
    queueRating: 'Rating {rating} · RD {rd}',
    queuePlacement: 'Placement · {n} left',
    queueLeagueLp: '{name} · {lp} LP',
    queueWindow: 'Own window: ±{n}',
    queueWindowOpen: 'Own window: open',
    queueAlone: 'Waiting for someone else.',
    queueNearestYes: 'Can pair with {name} (gap {diff}).',
    queueNearestNo: 'Closest is {name}, gap {diff}. Still {short} outside the window.',
    queueShowDeck: 'Show deck',
    queueHideDeck: 'Hide deck',
    queueMat: 'Playmat: {name}',
    queueAccount: 'Open account',
    liveEnd: 'End duel',
    liveEndConfirm: 'End it',
    liveEndCancel: 'Cancel',
    usersTotal: 'Accounts',
    activeDay: 'Active today',
    activeWeek: 'Active this week',
    newWeek: 'New this week',
    dropoutTitle: 'Dropout rate',
    dropoutLead: 'Accounts older than 7 days. Did not return: a single sign-in.',
    dropoutGauge: 'Dropout {n} percent',
    dropoutCreated: 'Created',
    dropoutReturned: 'Came back at some point',
    dropoutGone: 'Did not return',
    dropoutWeeks: 'By signup week',
    dropoutWeeksLead: 'A second sign-in within 7 days. Only weeks that have already closed.',
    dropoutBack: 'Came back',
    dropoutNever: 'Did not return',
    dropoutCurve: 'Return curve',
    dropoutCurveLead:
      'Share with a second sign-in by that day. Accounts from the last 120 days that are already that old.',
    dropoutDay: 'Day {n}',
    packsWeek: 'Packs opened (7d)',
    coinsWeek: 'Coins minted / spent (7d)',
    chatWeek: 'Chat messages (7d)',
    logsLead: 'Each list has its own tab. Overview only shows the totals.',
    logs: {
      stall: 'Freezes',
      fault: 'Faults',
      summon: 'Summons',
      probe: 'Cases',
      entry: 'Check-in',
      pvp: 'PvP',
    },
    probeLog: 'Rejected clicks, connections, and undrawn cards (7d)',
    probeLead:
      'A rejection is a click the server refused. A connection row is the socket. Undrawn means the duel had a card the board did not show.',
    probe: {
      action_rejected: 'Rejected',
      duel_link: 'Connection',
      board_gap: 'Undrawn',
      duel_hidden: 'Tab hidden',
    },
    entryLead:
      'The first time a player opens their tournament room. Dialog is the on-screen prompt. Notice is the system notification. Bracket is the button on the bracket. Next round is when the game moves them on its own.',
    entryHow: 'How they entered',
    entryVia: {
      dialog: 'Dialog',
      notice: 'Notification',
      bracket: 'Bracket',
      advance: 'Next round',
      unknown: 'Unknown',
    },
    pvpLogLead:
      'Plays from duels between two people, with both opening hands. Older duels are not listed.',
    pvpLogHands: 'Opening hands',
    pvpLogFirst: '{name} goes first',
    pvpLogTrimmed: 'The earliest plays were dropped. This is the ending.',
    pvpLogOpen: 'Show plays',
    pvpLogClose: 'Hide plays',
    pvpLogLoading: 'Loading plays…',
    pvpLogSet: '{name} set {card}',
    pvpLogGy: '{card} went to the Graveyard',
    pvpLogPeek: '{name} looked at {cards}',
    pvpLogPeekReveal: '{name} revealed {cards}',
    pvpLogAsk: '{name} must choose for {card}: {target} ({where})',
    pvpLogAskLeft:
      '{name} still had to choose a target for {card} when the duel ended ({n})',
    pvpAsk: {
      set: 'Set',
      def: 'Defense',
      atk: 'Attack',
      up: 'face-up',
      gy: 'Graveyard',
      hand: 'hand',
      deck: 'Deck',
      ban: 'removed from play',
      extra: 'Extra Deck',
      zone: '{where}, zone {n}',
    },
    summonLocksWeek: 'Summon lock (7d)',
    summonLockLog: 'Recent summon locks',
    summonLock: {
      throw: 'Animation failed',
      watchdog: 'The safety unlocked the board',
      resync: 'Asked for the board again',
    },
    stallsWeek: 'Battle Phase freezes (7d)',
    stallReason: 'Cause',
    stall: {
      playback: 'Animation stuck',
      substep: 'Battle step stuck',
      prompt: 'Prompt missing',
      ai: 'AI not moving',
    },
    stallLog: 'Latest freezes',
    stallTurn: 'Turn',
    stallSeat: 'To play',
    stallAnswer: 'Must answer',
    stallMe: 'this player',
    stallOpp: 'the opponent',
    stallPrompt: 'Window',
    stallAttack: 'Attack',
    stallChain: 'Chain',
    stallField: 'Monsters',
    stallBack: 'Spells and traps',
    stallRecent: 'Last events',
    faultsWeek: 'Trap Hole, Offering, Last Will (7d)',
    faultLog: 'Latest card faults',
    faultCard: 'Card',
    faultCardName: {
      trap_hole: 'Trap Hole',
      offering: 'Ultimate Offering',
      last_will: 'Last Will',
    },
    fault: {
      target: 'Asked for a target',
      prompt: 'Prompt missing',
      offering_hand: 'Hand blocked after paying',
      wrong_turn: 'Triggered off its turn',
    },
    duelsWeek: 'Duels (7d)',
    aiWeek: 'Vs AI (7d)',
    mode: 'Mode',
    count: 'Count',
    wins: 'Wins',
    difficulty: 'Difficulty',
    username: 'Username',
    email: 'Email',
    lastSeen: 'Last seen',
    level: 'Level',
    coins: 'Coins',
    duelsCol: 'Duels',
    playTime: 'Time played',
    playMinutes: '{n} min',
    playHours: '{n} h',
    playHoursMinutes: '{h} h {m} min',
    collectionCol: 'Cards',
    decksCol: 'Decks',
    uniqueShort: '{n} unique',
    created: 'Created',
    albumCopies: 'Cards owned',
    album: 'Unique cards',
    decks: 'Decks',
    deckActive: 'In use',
    deckMain: 'Main deck',
    deckExtra: 'Extra deck',
    recentDuels: 'Recent duels',
    recentPackBuys: 'Recent pack purchases',
    packBuyItem: 'Pack',
    packBuyOk: 'Bought',
    recentChat: 'Recent chat',
    settingsSaved: 'Saved {when}',
    prefOn: 'On',
    prefOff: 'Off',
    channel: 'Channel',
    allChats: 'All chats',
    chatGlobal: 'Global',
    chatRoom: 'Duel',
    chatSearch: 'Username or message',
    when: 'When',
    result: 'Result',
    source: 'Source',
    allModes: 'All modes',
    rankedLead:
      'Each Quick Match is stored with the league points of both players. Older matches only show the point change.',
    rankedSearch: 'Username',
    rankedCount: '{n} matches',
    rankedPlayer: 'Player',
    rankedOpponent: 'Opponent',
    rankedPoints: 'Points',
    rankedAfter: 'After',
    rankedWinner: 'Won',
    rankedHistory: 'Ranked',
    rankedPlayed: 'Matches',
    rankedWins: 'Wins',
    rankedLosses: 'Losses',
    rankedDraws: 'Draws',
    rankedGained: 'Points gained',
    rankedLost: 'Points lost',
    rankedWin: 'Win',
    rankedLoss: 'Loss',
    rankedDraw: 'Draw',
    rankedPlacement: 'Placement · {n} left',
    rankedPlacementDone: 'Placement finished',
    rankedNone: 'No rank',
    rankedStanding: 'Rank',
    rankedCol: 'Ranked',
  },
}
